import React, { useEffect, useState } from "react";
import {
  TextInput,
  Container,
  Notification,
  Group,
  Checkbox,
  MultiSelect,
  Modal,
  Radio,
} from "@mantine/core";
import "../../style/createAppointment.css";
import { useLocation, useNavigate } from "react-router-dom";
import { IconArrowLeft, IconSearch, IconX } from "@tabler/icons";
import { Button } from "@material-ui/core";
import { Col, Row } from "react-flexbox-grid";
import NavigoDashboardUtils from "../../services/NavigoDashboardUtils";
import { showNotification } from "@mantine/notifications";
import SearchDropdown, { StylesConfig } from "react-select";
import { DatePicker } from "@mantine/dates";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import Dialog from "@material-ui/core/Dialog";
import "../../style/dashboard.css";
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import AddressService from "../../services/AddressService";
import NoRecordsIcon from "../../assets/no-records.png";
import { Loader } from "@mantine/core";
import { LocationSearchDialog, useLocationDialog } from "./useLocationDialog";
import { LOCATION_MODE } from "../../helper/appointmentConstants";
import PaymentLinkDialog from "./payment/PaymentLinkDialog";
import { useAddressFlow } from "./GeoAddress/useAddressFlow";
import AddressFlowDialog from "./GeoAddress/AddressFlowDialog";

export const NotificationStyles = {
  position: "fixed",
  left: "0",
  bottom: "40px",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
} as React.CSSProperties;

function CreateAppointment(props: any) {
  const location = useLocation();
  const [totalModes, setTotalModes] = useState([]);
  const [patientIdTyped, setPatientIdTyped] = useState("");
  const [isPidSearched, setIsPidSearched] = useState(false);
  const [patientDetails, setPatientDetails] = useState<PatientType | null>(
    null,
  );
  const [relationsList, setRelationsList] = useState<RelationType[]>([]);
  const [reasonList, setReasonList] = useState<ReasonOption[]>([]);
  const [reasonSelected, setReasonSelected] = useState<ReasonType | null>(null);
  const [reasonDesc, setReasonDesc] = useState<string>("");
  const [accountList, setAccountList] = useState<AccountOption[]>([]);
  const [accountSelected, setAccountSelected] = useState<string | null>(null);
  const [familyMemberList, setFamilyMemberList] = useState<
    FamilyMemberOption[]
  >([]);
  const [selectedFamilyMember, setSelectedFamilyMember] =
    useState<FamilyMember | null>(null);
  const [planList, setPlanList] = useState<PlanTypeOption[]>([]);
  const [planSelected, setPlanSelected] = useState<PlanType | null>(null);
  const [serviceTypeList, setServiceTypeList] = useState<ServiceTypeOption[]>(
    [],
  );
  const [serviceTypeSelected, setServiceTypeSelected] =
    useState<ServiceTypeOption | null>(null);
  const [serviceListToShow, setServiceListToShow] = useState<ServiceOption[]>(
    [],
  );
  const [serviceSelected, setServiceSelected] = useState<ServiceType | null>(
    null,
  );
  const [serviceModeList, setServiceModeList] = useState<ServiceModeOption[]>(
    [],
  );
  const [serviceModeSelected, setServiceModeSelected] =
    useState<ServiceMode | null>(null);
  const [selectServiceProviderCheckbox, setSelectServiceProviderCheckbox] =
    useState(false);
  const [serviceProviderListToShow, setServiceProviderListToShow] = useState<
    ServiceProviderOption[]
  >([]);
  const [serviceProviderSelected, setServiceProviderSelected] =
    useState<ServiceProviderType | null>(null);
  const [serviceProviderAutoSelected, setServiceProviderAutoSelected] =
    useState<number | null>(null);
  const [dateSelected, setDateSelected] = useState<Date | null>(null);
  const [slotList, setSlotList] = useState<SlotOption[]>([]);
  const [slotSelected, setSlotSelected] = useState<SlotOption | null>(null);
  const [vendor, setVendor] = useState<string>("");
  const [vendorCode, setVendorCode] = useState<string>("");
  const [vendorDrId, setVendorDrId] = useState(0);
  const [addressList, setAddressList] = useState<AddressOption[]>([]);
  const [addressSelected, setAddressSelected] = useState<number | null>(null);
  const [languagesList, setLanguagesList] = useState<string[]>([]);
  const [languagesSelected, setLanguagesSelected] = useState<string[]>([]);
  const [patientContactNumber, setPatientContactNumber] = useState<
    string | null
  >(null);
  const [patientContactNumberCheckbox, setPatientContactNumberCheckbox] =
    useState<boolean>(false);
  const [homeSampleDateMin, setHomeSampleDateMin] = useState<number | null>(
    null,
  );
  const [homeSampleDateMax, setHomeSampleDateMax] = useState<number | null>(
    null,
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [showPaymentLinkDialog, setShowPaymentLinkDialog] =
    useState<boolean>(false);
  const [payloadForCreateAppointment, setPayloadForCreateAppointment] =
    useState<any>(null);
  const [aptPrice, setAptPrice] = useState<number | null>(null);
  const [statesLocs, setStatesLocs] = useState<LocOption[]>([]);
  const [stateSelected, setStateSelected] = useState<string | null>(null);
  const [cityLocs, setCityLocs] = useState<LocOption[]>([]);
  const [citySelected, setCitySelected] = useState<string | null>(null);
  const [localityLocs, setLocalityLocs] = useState<LocOption[]>([]);
  const [localitySelected, setLocalitySelected] = useState<string | null>(null);
  const [updatePatientInfoDialog, setUpdatePatientInfoDialog] =
    useState<boolean>(false);
  const [loadingProfileUpdate, setLoadingProfileUpdate] =
    useState<boolean>(false);
  const [patientInfo, setPatientInfo] = useState<PatientInfo | null>(null);
  const [newDob, setNewDob] = useState<Date | null>(null);
  const [newEmail, setNewEmail] = useState<string>("");
  const [isOpenAddAddress, setIsOpenAddAddress] = useState<boolean>(false);
  let [district, setDistrict] = React.useState<string>("");
  let [pincode, setPincode] = React.useState<string>("");
  let [state, setState] = React.useState<string>("");
  let [city, setCity] = React.useState<string>("");
  let [line1, setLine1] = React.useState<string>("");
  let [line2, setLine2] = React.useState<string>("");
  let [landmark, setLandmark] = React.useState<string>("");
  let [type, setType] = React.useState<string>("");
  let [name, setName] = React.useState<string>("");
  let [phoneNo, setPhoneNo] = React.useState<string>("");
  let [countryCode, setCountryCode] = React.useState<string>("91");
  let [errorFlag, setErrorFlag] = React.useState<boolean>(false);

  const [openAssignPlanDialog, setOpenAssignPlanDialog] =
    useState<boolean>(false);
  const [loadingAssignPlan, setLoadingAssignPlan] = useState<boolean>(false);
  const [loadingTable, setLoadingTable] = useState<boolean>(false);
  const [loadingTable2, setLoadingTable2] = useState<boolean>(false);
  const [accountsOnPid, setAccountsOnPid] = useState<AccountType[]>([]);
  const [plansOnPid, setPlansOnPid] = useState<any>([]);
  const [accountRadioSelected, setAccountRadioSelected] = useState<string>("");
  const [plansOnAccount, setPlansOnAccount] = useState<any>([]);
  const [plansSelected, setPlansSelected] = useState<any>([]);
  const [plansSelected2, setPlansSelected2] = useState<any>([]);
  const [openPlansAssignedDialog, setOpenPlansAssignedDialog] =
    useState<boolean>(false);
  const [plansAssignmentResponse, setPlansAssignmentResponse] = useState<any>(
    [],
  );
  const [availCareDateMin, setAvailCareDateMin] = useState<number | null>(null);
  const [availCareDateMax, setAvailCareDateMax] = useState<number | null>(null);
  const [checkAddressServiceableResponse, setCheckAddressServiceableResponse] =
    useState<any>(null);
  const [locationModeSelected, setLocationModeSelected] =
    useState<LocationModeOption | null>(null);
  const [geoLocData, setGeoLocData] = useState<GeoLocationData | null>(null);
  const [rangeOptionSelected, setRangeOptionSelected] =
    useState<LocationRangeOption | null>(null);
  const [priorityVendorMappedSpIds, setPriorityVendorMappedSpIds] = useState<
    number[]
  >([]);
  const [
    addressNotServiceableForPriorityVendors,
    setAddressNotServiceableForPriorityVendors,
  ] = useState<boolean>(false);

  const navigoDashboardUtils = new NavigoDashboardUtils();
  let as = new AddressService();

  dayjs.extend(utc);
  let addressTypes = ["Home", "Work", "Other"];

  const MODES_WITH_AUTO_SP = [
    "Video consultation",
    "Tele consultation",
    "Home sample",
  ];

  let SELECT_LOCATION_MODE_OPTIONS: LocationModeOption[] = [
    {
      label: "Google maps",
      value: LOCATION_MODE.GOOGLE_MAPS,
    },
    {
      label: "Manual",
      value: LOCATION_MODE.MANUAL,
    },
    {
      label: "Saved Addresses",
      value: LOCATION_MODE.SAVED_ADDRESSES,
    },
  ];
  const AUTO_RADIUS_SEQUENCE = [6, 10, 15];

  const LOCATION_RANGE_KMS_OPTIONS: LocationRangeOption[] = [
    { label: "6 Km", value: 6 },
    { label: "10 Km", value: 10 },
    { label: "15 Km", value: 15 },
    { label: "30 Km", value: 30 },
    { label: "50 Km", value: 50 },
    { label: "75 Km", value: 75 },
    { label: "100 Km", value: 100 },
  ];

  let navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id");

    const isPositiveInteger = (value: any) => {
      const num = Number(value);
      return Number.isInteger(num) && num > 0;
    };

    if (!isPositiveInteger(id)) {
      showNotification({
        title: "Invalid patient ID",
        message: "",
        color: "red",
      });
    } else {
      getModes();
      getAllRelation();
      fetchReasonsForConsultation();
      fetchPriorityVendors();
      setPatientIdTyped(String(id));
    }
  }, []);

  useEffect(() => {
    if (patientIdTyped !== "") {
      searchPatient();
    }
  }, [patientIdTyped]);

  useEffect(() => {
    if (isPidSearched) {
      getAccountsForPid(patientIdTyped);
      getFamilyMembers(patientIdTyped);
      getPatientAddress(patientIdTyped);
    } else {
      setAccountList([]);
      setAccountSelected(null);
      setFamilyMemberList([]);
      setAddressList([]);
      setAddressSelected(null);
    }
  }, [isPidSearched]);
  useEffect(() => {
    clearGeoLocData();
    if (accountSelected) {
      getPlansForPid(patientIdTyped, accountSelected);
      setPlanSelected(null);
    } else {
      setPlanSelected(null);
    }
  }, [accountSelected]);
  useEffect(() => {
    clearGeoLocData();
    if (planSelected != null) {
      setServiceTypeSelected(null);
      let types: ServiceTypeOption[] = totalModes
        .filter((e: any) => {
          if (planSelected.bookConsultation && e.id === 1) {
            return true;
          } else if (planSelected.bookHealthCheckup && e.id === 2) {
            return true;
          } else if (planSelected.bookVaccination && e.id === 3) {
            return true;
          } else {
            return false;
          }
        })
        .map((e: any) => {
          return {
            label: e.name,
            value: e.id,
          };
        });
      setServiceTypeList(types);
    } else {
      setServiceTypeList([]);
      setServiceTypeSelected(null);
    }
  }, [planSelected, totalModes]);

  // useEffect(() => {
  //   if (serviceTypeSelected != null) {
  //     setServiceSelected(null);
  //     getServices();
  //   } else {
  //     setServiceSelected(null);
  //     // setServiceTypeList([]);
  //   }
  // }, [serviceTypeSelected]);

  useEffect(() => {
    clearGeoLocData();
    if (serviceTypeSelected != null) {
      setSelectedFamilyMember(null);
    } else {
      setSelectedFamilyMember(null);
    }
  }, [serviceTypeSelected]);

  useEffect(() => {
    clearGeoLocData();
    if (selectedFamilyMember != null) {
      setServiceSelected(null);
      setServiceListToShow([]);
      getFamilyDetails(selectedFamilyMember.memberPatientId, false);
    } else {
      setServiceSelected(null);
      setServiceListToShow([]);
    }
  }, [selectedFamilyMember]);

  useEffect(() => {
    clearGeoLocData();
    if (serviceSelected != null) {
      setServiceModeSelected(null);
      setServiceModeList(
        serviceSelected.serviceModeDetails === null ||
          serviceSelected.serviceModeDetails.length === 0
          ? []
          : serviceSelected.serviceModeDetails.map((e: ServiceMode) => {
              return {
                label: `${e.modeName} ${
                  e.hasDifferentialPricing
                    ? "(price varies on service provider)"
                    : `(Rs ${e.discountedPrice})`
                }`,
                value: e,
              };
            }),
      );
      if (serviceSelected.serviceSubTypeId === 3) {
        getAvailCareDates();
      } else {
        setAvailCareDateMin(null);
        setAvailCareDateMax(null);
      }
    } else {
      setServiceModeSelected(null);
      setServiceModeList([]);
      setAvailCareDateMin(null);
      setAvailCareDateMax(null);
    }
  }, [serviceSelected]);
  useEffect(() => {
    if (!serviceModeSelected || !serviceTypeSelected) {
      // reset everything when service mode or type is not selected
      setLanguagesList([]);
      setLanguagesSelected([]);
      setSelectServiceProviderCheckbox(false);
      setServiceProviderSelected(null);
      setServiceProviderListToShow([]);
      setStateSelected(null);
      setStatesLocs([]);
      setCitySelected(null);
      setCityLocs([]);
      setLocalitySelected(null);
      setLocalityLocs([]);
      setHomeSampleDateMin(null);
      setHomeSampleDateMax(null);
      setAddressSelected(null);
      return;
    }
    clearGeoLocData();

    setAddressSelected(null);
    setReasonSelected(null);
    setReasonDesc("");
    if (serviceTypeSelected.value === 1) {
      if (serviceModeSelected.modeName === "In person consultation") {
        setSelectServiceProviderCheckbox(false);
        setServiceProviderSelected(null);
        setServiceProviderListToShow([]);
        setLanguagesList([]);
        setLanguagesSelected([]);
        getSPLocation({
          state: null,
          city: null,
          locality: null,
          type1: "state",
        });
        setStateSelected(null);
      } else {
        // Type 1 → Always show location filter
        setStateSelected(null);
        setStatesLocs([]);
        setCitySelected(null);
        setCityLocs([]);
        setLocalitySelected(null);
        setLocalityLocs([]);

        fetchLanguages(buildLocationFilter(null, null, null)); // includes locationFilter if provided

        if (serviceModeSelected != null) {
          getServiceProvider({});
        }
        setSelectServiceProviderCheckbox(false);
        setServiceProviderSelected(null);
        setServiceProviderListToShow([]);
      }
    }

    if (serviceTypeSelected.value === 2 || serviceTypeSelected.value === 3) {
      // Type 2 → Only location-based filters
      setSelectServiceProviderCheckbox(false);
      setServiceProviderSelected(null);

      if (
        serviceModeSelected.modeName === "Centre visit" ||
        serviceModeSelected.modeName === "Camp site visit"
      ) {
        setAddressSelected(null);
        // trigger state dropdown population
        setSelectServiceProviderCheckbox(false);
        setServiceProviderSelected(null);
        setServiceProviderListToShow([]);
        getSPLocation({
          state: null,
          city: null,
          locality: null,
          type1: "state",
        });
        setStateSelected(null);
      } else {
        setStateSelected(null);
        setStatesLocs([]);
        setCitySelected(null);
        setCityLocs([]);
        setLocalitySelected(null);
        setLocalityLocs([]);
        // for modes other than "Centre visit"/"Camp site visit"
        setSelectServiceProviderCheckbox(false);
        setServiceProviderSelected(null);
        setServiceProviderListToShow([]);
        getServiceProvider({});
        setStateSelected(null);
      }

      if (
        serviceModeSelected.modeName === "Home sample" &&
        serviceTypeSelected.value === 2
      ) {
        getHomeSampleDates();
      } else {
        setHomeSampleDateMin(null);
        setHomeSampleDateMax(null);
      }
    }
  }, [serviceModeSelected]);
  useEffect(() => {
    if (languagesSelected.length > 0) {
      setSelectServiceProviderCheckbox(false);
      setServiceProviderSelected(null);
      if (
        locationModeSelected?.value === LOCATION_MODE.GOOGLE_MAPS ||
        locationModeSelected?.value === LOCATION_MODE.SAVED_ADDRESSES
      ) {
        getServiceProvider({
          languages: languagesSelected,
          range: {
            latLng: geoLocData?.latLng ?? DEFAULT_NEW_DELHI_LATLNG,
            radius: rangeOptionSelected?.value ?? 0,
            autocheck: false,
          },
        });
      } else {
        getServiceProvider({
          state: stateSelected!,
          city: citySelected!,
          locality: localitySelected!,
          languages: languagesSelected,
        });
      }
    }
    // else {
    //   if (serviceModeSelected != null) {
    //     getServiceProvider({
    //       state: stateSelected!,
    //       city: citySelected!,
    //       locality: localitySelected!,
    //     });
    //   }
    //   setSelectServiceProviderCheckbox(false);
    //   setServiceProviderSelected(null);
    //   setServiceProviderListToShow([]);
    // }
  }, [languagesSelected]);

  useEffect(() => {
    setServiceProviderSelected(null);
    setServiceProviderListToShow([]);
    setSelectServiceProviderCheckbox(false);
    setCityLocs([]);
    setCitySelected(null);
    setLocalitySelected(null);
    setLocalityLocs([]);
    if (stateSelected != null) {
      getSPLocation({
        state: stateSelected,
        city: null,
        locality: null,
        type1: "city",
      });
    }
    // if (stateSelected && serviceTypeSelected?.value === 1) {
    //   fetchLanguages(
    //     buildLocationFilter(stateSelected, citySelected, localitySelected)
    //   );
    // }
    if (stateSelected && serviceTypeSelected?.value === 1) {
      setLanguagesList([]);
      setLanguagesSelected([]);
    }
  }, [stateSelected]);
  useEffect(() => {
    setServiceProviderSelected(null);
    setServiceProviderListToShow([]);
    setSelectServiceProviderCheckbox(false);
    setLocalitySelected(null);
    setLocalityLocs([]);
    if (citySelected != null) {
      getSPLocation({
        state: stateSelected,
        city: citySelected,
        locality: null,
        type1: "locality",
      });
    }
    if (citySelected && serviceTypeSelected?.value === 1) {
      fetchLanguages(
        buildLocationFilter(stateSelected, citySelected, localitySelected),
      );
    }
  }, [citySelected]);
  useEffect(() => {
    setServiceProviderSelected(null);
    setServiceProviderListToShow([]);
    setSelectServiceProviderCheckbox(false);
    if (localitySelected != null) {
      getServiceProvider({
        state: stateSelected!,
        city: citySelected!,
        locality: localitySelected!,
      });
    }
    if (localitySelected && serviceTypeSelected?.value === 1) {
      fetchLanguages(
        buildLocationFilter(stateSelected, citySelected, localitySelected),
      );
    }
  }, [localitySelected]);

  useEffect(() => {
    setServiceProviderSelected(null);
    setDateSelected(null);
    if (
      addressSelected &&
      serviceSelected?.serviceId &&
      hasLocationFilter() === false
    ) {
      checkAddressServiceable(addressSelected);
    }
  }, [addressSelected]);

  useEffect(() => {
    setServiceProviderSelected(null);
    setDateSelected(null);
  }, [selectServiceProviderCheckbox]);

  useEffect(() => {
    if (
      serviceProviderSelected != null &&
      selectServiceProviderCheckbox == false
    ) {
      setDateSelected(null);
    }
  }, [serviceProviderSelected]);

  // useEffect(() => {
  //   if (selectedFamilyMember != null) {
  //     getFamilyDetails(selectedFamilyMember.memberPatientId, false);
  //     setDateSelected(null);
  //   } else {
  //     setPrice("");
  //     setDateSelected(null);
  //     setAddressSelected(null);
  //   }
  // }, [selectedFamilyMember]);

  useEffect(() => {
    if (dateSelected != null) {
      setSlotSelected(null);
      setServiceProviderAutoSelected(null);
      setVendor("");
      setVendorCode("");
      setVendorDrId(0);
      getAvailableSlots(dateSelected);
    } else {
      setSlotSelected(null);
      setServiceProviderAutoSelected(null);
      setVendor("");
      setVendorCode("");
      setVendorDrId(0);
      setSlotList([]);
    }
  }, [dateSelected]);
  useEffect(() => {
    if (patientContactNumberCheckbox) {
    } else {
      setPatientContactNumber(String(patientDetails?.phoneno));
    }
  }, [patientContactNumberCheckbox]);

  useEffect(() => {
    if (openAssignPlanDialog) {
      getPatientActiveAcc();
      setPlansSelected2([]);
      setPlansAssignmentResponse([]);
    }
  }, [openAssignPlanDialog]);

  useEffect(() => {
    if (accountRadioSelected != "") {
      getFilteredPlans();
    } else {
      setPlansOnAccount([]);
    }
  }, [accountRadioSelected]);

  useEffect(() => {
    clearGeoLocData2();
  }, [locationModeSelected]);
  // useEffect(() => {
  //   clearGeoLocData3();
  // }, [geoLocData]);
  useEffect(() => {
    clearGeoLocData4();
  }, [rangeOptionSelected]);

  useEffect(() => {
    if (slotSelected != null) {
      let finalPrice = null;
      if (selectServiceProviderCheckbox) {
        const matchedSP = serviceProviderListToShow.find(
          (sp) => sp.value.id === serviceProviderAutoSelected,
        );
        finalPrice = matchedSP?.value?.price;
      } else {
        finalPrice = serviceProviderSelected?.price;
      }

      if (finalPrice != null && !isNaN(finalPrice) && finalPrice >= 0) {
        setAptPrice(finalPrice);
      }
    } else {
      setAptPrice(null);
    }
  }, [slotSelected]);

  const clearGeoLocData = () => {
    setLocationModeSelected(null);
    setGeoLocData(null);
    setRangeOptionSelected(null);
    setAddressNotServiceableForPriorityVendors(false);
    setLanguagesSelected([]);
    setServiceProviderSelected(null);
    setDateSelected(null);
    setServiceProviderListToShow([]);
    setSelectServiceProviderCheckbox(false);
  };
  const clearGeoLocData2 = () => {
    setAddressSelected(null);

    setStateSelected(null);
    setCitySelected(null);
    setCityLocs([]);
    setLocalitySelected(null);
    setLocalityLocs([]);

    setGeoLocData(null);
    setRangeOptionSelected(null);
    setLanguagesSelected([]);
    setServiceProviderSelected(null);
    setDateSelected(null);
    setServiceProviderListToShow([]);
    setSelectServiceProviderCheckbox(false);
  };
  const clearGeoLocData3 = () => {
    setRangeOptionSelected(null);
    setLanguagesSelected([]);
    setServiceProviderSelected(null);
    setDateSelected(null);
    setServiceProviderListToShow([]);
    setSelectServiceProviderCheckbox(false);
  };

  const clearGeoLocData4 = () => {
    setLanguagesSelected([]);
    setServiceProviderSelected(null);
    setDateSelected(null);
    setServiceProviderListToShow([]);
    setSelectServiceProviderCheckbox(false);
  };

  const handleSearchPatient = () => {
    if (isPidSearched) {
      setPatientIdTyped("");
      setIsPidSearched(false);
      setPatientDetails(null);
    } else {
      // Search
      if (patientIdTyped.trim() !== "") {
        searchPatient();
      }
    }
  };
  const searchPatient = () => {
    let onResponse = (res: any) => {
      if (res != null && res.status != 3) {
        getPatientDetails(false);
      } else {
        showNotification({
          title: "Patient status is not active",
          message: "",
          color: "red",
        });
      }
    };
    let onError = (err: any) => {
      showNotification({
        title: "No patient found",
        message: err?.message,
        color: "red",
      });
    };

    navigoDashboardUtils.getPatient(patientIdTyped, onResponse, onError);
  };
  const getPatientDetails = (skipEmail: boolean) => {
    let onResponse = (res: PatientType) => {
      if (res == null || res.status === 3) {
        showNotification({
          title: "Patient status is not active",
          message: "",
          color: "red",
        });
        return;
      }
      if (res != null) {
        const mapped: PatientInfo = {
          patientId: res.id,
          firstName: res.firstName,
          lastName: res.lastName,
          gender: res.gender,
          dateOfBirth: res.dateOfBirth,
          phoneNo: res.phoneno,
          email: res.email,
          profileImage: res.profileImage,
          countryCode: res.countrycode,
        };
        if (
          isDOBEmpty(mapped) ||
          (skipEmail === false && skipEmail === false && isEmailEmpty(mapped))
        ) {
          setPatientInfo(mapped);
          setUpdatePatientInfoDialog(true);
        } else {
          setPatientDetails(res);
          setPhoneNo(String(res.phoneno));
          setName(String(`${res.firstName} ${res.lastName}`));
          setPatientContactNumber(String(res.phoneno));
          setIsPidSearched(true);
        }
      }
    };
    let onError = (err: any) => {
      showNotification({
        title: "No patient found",
        message: err?.message,
        color: "red",
      });
    };

    navigoDashboardUtils.getPatientDetails(patientIdTyped, onResponse, onError);
  };
  const getFamilyDetails = (pid: number, skipEmail: boolean) => {
    let onResponse = (res: PatientType) => {
      if (res == null || res.status === 3) {
        showNotification({
          title: "Patient status is not active",
          message: "",
          color: "red",
        });
        return;
      }
      if (res != null) {
        const mapped: PatientInfo = {
          patientId: res.id,
          firstName: res.firstName,
          lastName: res.lastName,
          gender: res.gender,
          dateOfBirth: res.dateOfBirth,
          phoneNo: res.phoneno,
          email: res.email,
          profileImage: res.profileImage,
          countryCode: res.countrycode,
        };
        if (
          isDOBEmpty(mapped) ||
          (skipEmail === false && skipEmail === false && isEmailEmpty(mapped))
        ) {
          setPatientInfo(mapped);
          setUpdatePatientInfoDialog(true);
          // setSelectedFamilyMember(null);
        } else {
          getServices();
        }
      }
    };
    let onError = (err: any) => {
      showNotification({
        title: "No patient found",
        message: err?.message,
        color: "red",
      });
    };

    navigoDashboardUtils.getPatientDetails(String(pid), onResponse, onError);
  };

  const fetchPriorityVendors = () => {
    const onResponse = (res: any) => {
      const ids =
        res == null || res.length === 0
          ? []
          : res.map((v: any) => v.mappedServiceProviderId);
      setPriorityVendorMappedSpIds(ids);
    };
    const onError = (err: any) => {
      showNotification({
        title: "Error fetching priority vendors",
        message: err?.message,
        color: "red",
      });
    };
    navigoDashboardUtils.getPriorityVendors(onResponse, onError);
  };

  const getModes = () => {
    let onResponse = (res: any) => {
      setTotalModes(res == null || res.length === 0 ? [] : res);
    };
    let onError = (err: any) => {
      showNotification({
        title: "Error in fetching modes:",
        message: err?.message,
        color: "red",
      });
    };
    navigoDashboardUtils.getModes(onResponse, onError);
  };
  const getAllRelation = () => {
    const onResponse = (res: RelationType[]) => {
      if (res != null) {
        let relations = res;
        relations.unshift({ code: 0, value: "Self", gender: 0 });
        setRelationsList(relations);
      }
    };
    const onError = (err: any) => {
      showNotification({
        title: "Error in fetching relations:",
        message: err?.message,
        color: "red",
      });
    };
    navigoDashboardUtils.getAllRelation(onResponse, onError);
  };

  const fetchReasonsForConsultation = () => {
    const onResponse = (res: any) => {
      setReasonList(
        res == null || res.length == 0
          ? []
          : res
              .filter((e: any) => e.isActive === true)
              .map((e: ReasonType) => {
                return {
                  label: e.name,
                  value: {
                    id: e.id,
                    name: e.name,
                  },
                };
              }),
      );
    };
    const onError = (err: any) => {
      showNotification({
        title: "Error in fetching reasons for consultation:",
        message: err?.message,
        color: "red",
      });
    };
    navigoDashboardUtils.fetchReasonsForConsultation(onResponse, onError);
  };
  const getAccountsForPid = (id: string) => {
    setLoading(true);
    const onResponse = (res: any) => {
      if (
        res != null &&
        res.patientAccounts != null &&
        res.patientAccounts.length > 0
      ) {
        setAccountList(
          res.patientAccounts.map((acc: any) => ({
            value: acc.accountCode,
            label: `(${acc.accountCode}) ${acc.accountName}`,
          })),
        );
      }
      setLoading(false);
    };
    const onError = (err: any) => {
      showNotification({
        title: "Error in fetching accounts:",
        message: err?.message,
        color: "red",
      });
      setLoading(false);
    };

    navigoDashboardUtils.getPatientActiveAcc(id, onResponse, onError);
  };
  const getRelationName = (code: number): string | undefined => {
    if (relationsList != null && relationsList.length > 0) {
      return relationsList.find((rel) => rel.code === code)?.value ?? undefined;
    } else {
      return undefined;
    }
  };
  const getFamilyMembers = (pid: string) => {
    const onResponse = (res: any) => {
      if (res != null) {
        let list = res.families.length === 0 ? [] : res.families;
        list = list.map((e: any) => {
          return { ...e, ageToShow: getAgeYearFromDob(e?.dateOfBirth) };
        });
        list.unshift({
          firstName: patientDetails?.firstName ?? "",
          lastName: patientDetails?.lastName ?? "",
          memberPatientId: Number(pid),
          relation: 0,
          ageToShow: getAgeYearFromDob(patientDetails?.dateOfBirth),
          gender: patientDetails?.gender ?? 0,
        });
        list = list.map((e: any) => {
          return {
            ...e,
            relationStr:
              getRelationName(e.relation) === undefined
                ? ""
                : getRelationName(e.relation),
          };
        });

        setFamilyMemberList(
          list.map((e: FamilyMember) => {
            return {
              label: `(${e.memberPatientId}) ${e.firstName} ${e.lastName} (${
                e.gender === 1 ? "F" : e.gender === 2 ? "M" : ""
              }/${e.ageToShow}/${e.relationStr})`,
              value: {
                firstName: e.firstName,
                lastName: e.lastName,
                memberPatientId: e.memberPatientId,
                relation: e.relation,
                relationStr: e.relationStr,
              },
            };
          }),
        );
      }
    };
    const onError = (err: any) => {
      showNotification({
        title: "Error in fetching family members:",
        message: err?.message,
        color: "red",
      });
    };
    navigoDashboardUtils.getFamilyMembers(pid, onResponse, onError);
  };

  const getBookingConfigByVendor = (vendorId: string) => {
    setLoading(true);

    const onResponse = (res: any) => {
      if (res) {
        setHomeSampleDateMin(res.minBookingDays);
        setHomeSampleDateMax(res.maxAdvBookingDays);
      } else {
        setHomeSampleDateMin(null);
        setHomeSampleDateMax(null);
      }
      setLoading(false);
    };

    const onError = (err: any) => {
      setHomeSampleDateMin(null);
      setHomeSampleDateMax(null);
      showNotification({
        title: "Error in fetching booking config:",
        message: err?.message,
        color: "red",
      });
      setLoading(false);
    };

    navigoDashboardUtils.getBookingConfigByVendor(
      {
        patientID: Number(patientIdTyped),
        serviceID: serviceSelected?.serviceId,
        planID: planSelected?.planId,
        vendorId,
      },
      onResponse,
      onError,
    );
  };

  const checkAddressServiceable = (address: any) => {
    setAddressNotServiceableForPriorityVendors(false);
    setLoading(true);

    const onResponse = (res: any) => {
      setCheckAddressServiceableResponse(res);

      if (res?.serviceable) {
        if (
          serviceSelected?.serviceTypeId === 3 &&
          selectServiceProviderCheckbox
        ) {
          getBookingConfigByVendor(res.vendorId);
        } else {
          setLoading(false);
        }
      } else {
        const allArePriorityVendors = serviceProviderListToShow?.every((sp) =>
          priorityVendorMappedSpIds.includes(sp.value.id),
        );
        if (allArePriorityVendors) {
          showNotification({
            title: "Address not serviceable",
            message: "",
            color: "red",
          });
          setAddressSelected(null);
          setLoading(false);
        } else {
          setAddressNotServiceableForPriorityVendors(true);
          setLoading(false);
        }
      }
    };

    const onError = (err: any) => {
      setCheckAddressServiceableResponse(null);
      showNotification({
        title: "Error in checking serviceability:",
        message: err?.message,
        color: "red",
      });
      setAddressSelected(null);
      setLoading(false);
    };

    navigoDashboardUtils.checkAddressServiceable(
      {
        addressId: address ?? 0,
        serviceId: serviceSelected?.serviceId,
      },
      onResponse,
      onError,
    );
  };

  const getPlansForPid = (pid: string, accId: string) => {
    setLoading(true);

    const onResponse = (res: any) => {
      setPlanList(
        res == null || res.length == 0
          ? []
          : res
              .filter((e: any) => e.accountCode === accId && e.status === 1)
              .map((e: PlanType) => {
                return {
                  value: {
                    accountCode: e.accountCode,
                    accountName: e.accountName,
                    bookConsultation: e.bookConsultation,
                    bookHealthCheckup: e.bookHealthCheckup,
                    bookVaccination: e.bookVaccination,
                    name: e.name,
                    planId: e.planId,
                    price: e.price,
                    status: e.status,
                  },
                  label: `(${e.planId}) ${e.name}`,
                };
              }),
      );
      setLoading(false);
    };
    const onError = (err: any) => {
      setPlanList([]);
      showNotification({
        title: "Error in fetching plans:",
        message: err?.message,
        color: "red",
      });
      setLoading(false);
    };

    navigoDashboardUtils.getPlansForPid(pid, onResponse, onError);
  };
  const getServices = () => {
    setLoading(true);

    let body = {
      pageNum: 0,
      pageSize: 0,
      planId: planSelected?.planId,
      serviceType: serviceTypeSelected?.value,
      patientId: Number(patientIdTyped),
      memberPatientId: selectedFamilyMember?.memberPatientId,
      includeSubtypeIds: [],
      excludeSubtypeIds: [],
    };

    const onResponse = (res: any) => {
      setServiceListToShow(
        !res || !res.services || res.services.length === 0
          ? []
          : res.services.map((e: ServiceType) => {
              const modeDetails = e.serviceModeDetails || [];

              const modeNames = modeDetails
                .map((m: any) => m.modeName)
                .join(" / ");

              let priceText = "";

              if (modeDetails.length > 0) {
                const firstPrice = modeDetails[0]?.discountedPrice;

                if (firstPrice !== null && firstPrice !== undefined) {
                  priceText =
                    modeDetails.length === 1
                      ? ` (at Rs. ${firstPrice})`
                      : ` (starting from Rs. ${firstPrice})`;
                }
              }

              return {
                value: e,
                label: `(${e.serviceId}) ${e.serviceCode} / ${e.name} (${
                  modeNames || ""
                })${priceText}`,
              };
            }),
      );

      setLoading(false);
    };

    const onError = (err: any) => {
      setServiceListToShow([]);
      showNotification({
        title: "Error in fetching services:",
        message: err?.message,
        color: "red",
      });
      setLoading(false);
    };

    navigoDashboardUtils.getServices(body, onResponse, onError);
  };

  const getServiceProviderLabel = ({
    provider,
    serviceTypeSelected,
    serviceModeSelected,
  }: {
    provider: ServiceProviderType;
    serviceTypeSelected: ServiceTypeOption;
    serviceModeSelected: ServiceMode;
  }) => {
    if (!provider) return "";

    // CONSULT TYPE
    if (serviceTypeSelected?.value === 1) {
      if (!provider) return "";

      const isApolloSP =
        provider.vendorDoctorId && provider.vendorDoctorId !== 0;

      const doctorId = isApolloSP ? provider.vendorDoctorId : provider.id;

      const locationText = isApolloSP
        ? (provider?.address?.housing ?? "")
        : `${provider?.address?.city ?? ""} - ${
            provider?.address?.landmark ?? ""
          }`;

      if (serviceModeSelected?.modeName === "In person consultation") {
        return `(${doctorId}) ${provider.name} - ${locationText} (Rs ${provider.price})${
          (locationModeSelected?.value === LOCATION_MODE.GOOGLE_MAPS ||
            locationModeSelected?.value === LOCATION_MODE.SAVED_ADDRESSES) &&
          (provider?.distanceFromSource ?? -1) >= 0
            ? ` [${formatDistanceKm(provider?.distanceFromSource)}]`
            : ""
        }`;
      }

      return `(${provider.id}) ${provider.name} (Rs ${provider.price})`;
    } else if (
      serviceTypeSelected?.value === 2 ||
      serviceTypeSelected?.value === 3 ||
      serviceTypeSelected?.value === 5
    ) {
      // HC TYPE
      const showAddress =
        serviceModeSelected?.modeName === "Centre visit" ||
        serviceModeSelected?.modeName === "Camp site visit";

      const addressPart = showAddress
        ? ` - ${provider?.address?.city ?? ""} - ${
            provider?.address?.landmark ?? ""
          }`
        : "";

      return `(${provider.id}) ${provider.name}${addressPart} (Rs ${provider.price})${
        (locationModeSelected?.value === LOCATION_MODE.GOOGLE_MAPS ||
          locationModeSelected?.value === LOCATION_MODE.SAVED_ADDRESSES) &&
        (provider?.distanceFromSource ?? -1) >= 0
          ? ` [${formatDistanceKm(provider?.distanceFromSource)}]`
          : ""
      }`;
    }

    // Default fallback
    return `(${provider.id}) ${provider.name} (Rs ${provider.price})`;
  };

  const hasLocationFilter = (): boolean => {
    const locationBasedModes: string[] = [
      "In person consultation",
      "Centre visit",
      "Camp site visit",
    ];

    return locationBasedModes.includes(serviceModeSelected?.modeName ?? "");
  };

  const findRangeOptionByRadius = (
    radius: number,
  ): LocationRangeOption | null =>
    LOCATION_RANGE_KMS_OPTIONS.find((opt) => opt.value === radius) ?? null;

  const getServiceProvider = ({
    state = "",
    city = "",
    locality = "",
    languages = [],
    range,
  }: {
    state?: string;
    city?: string;
    locality?: string;
    languages?: string[];
    range?: RangeFilter;
  }) => {
    // If location-based mode but missing filters and range
    if (hasLocationFilter() && !state && !city && !range) {
      setServiceProviderListToShow([]);
      return;
    }

    setLoading(true);

    const executeCall = (currentRange?: RangeFilter, autoIndex = 0) => {
      const body: any = {
        pageNum: 0,
        pageSize: 0,
        planId: planSelected?.planId,
        serviceId: serviceSelected?.serviceId,
        serviceMode: serviceModeSelected?.modeName,
        patientId: Number(patientIdTyped),
        memberPatientId: selectedFamilyMember?.memberPatientId,
        languageMatch: languages,
      };

      // ---------- LOCATION FILTER ----------
      if (state) {
        body.locationFilter = [
          {
            stateMatch: state,
            ...(city && { cityMatch: city }),
            ...(locality && { landmarkMatch: locality }),
          },
        ];
      }

      // ---------- GEOLOCATION FILTER ----------
      if (currentRange?.latLng && currentRange?.radius) {
        body.geolocationFilter = {
          latitude: currentRange.latLng.lat,
          longitude: currentRange.latLng.lng,
          radius: currentRange.radius * 1000, // km → meters
        };
      }

      const onResponse = (res: any) => {
        const providers = res?.providers ?? [];

        if (providers.length > 0) {
          setServiceProviderListToShow(
            providers.map((e: ServiceProviderType) => ({
              label: getServiceProviderLabel({
                provider: e,
                serviceTypeSelected: serviceTypeSelected!,
                serviceModeSelected: serviceModeSelected!,
              }),
              value: {
                id: e.id,
                name: e.name,
                maxBookingDays: e.maxBookingDays,
                minBookingDays: e.minBookingDays,
                margin: e.margin,
                address: e.address,
                vendorId: e.vendorId,
                vendorCode: e.vendorCode,
                vendorDoctorId: e.vendorDoctorId,
                price: e.price,
                distanceFromSource: e.distanceFromSource ?? null,
                amenities: e.amenities ?? null,
              },
            })),
          );
          setLoading(false);
          return;
        }

        //  AUTO-CHECK RETRY LOGIC
        if (
          currentRange?.autocheck &&
          autoIndex < AUTO_RADIUS_SEQUENCE.length - 1
        ) {
          const nextRadius = AUTO_RADIUS_SEQUENCE[autoIndex + 1];

          // update selected dropdown option
          const nextRangeOpt = findRangeOptionByRadius(nextRadius);
          if (nextRangeOpt) {
            setRangeOptionSelected(nextRangeOpt);
          }

          executeCall(
            {
              ...currentRange,
              radius: nextRadius,
            },
            autoIndex + 1,
          );
          return;
        }

        // Not found even after retries of 3 radius levels
        setServiceProviderListToShow([]);
        showNotification({
          title: "No service provider found",
          message: hasLocationFilter()
            ? "Please try expanding your search radius"
            : "",
          color: "red",
        });
        setLoading(false);
      };

      const onError = (err: any) => {
        setServiceProviderListToShow([]);
        showNotification({
          title: "Error in fetching service provider:",
          message: err?.message,
          color: "red",
        });
        setLoading(false);
      };

      navigoDashboardUtils.getServiceProvider(body, onResponse, onError);
    };

    // ---------- START ----------
    executeCall(range, AUTO_RADIUS_SEQUENCE.indexOf(range?.radius ?? 0));
  };

  const selectStyles: StylesConfig<any, false> = {
    singleValue: (base) => ({
      ...base,
      whiteSpace: "normal",
      lineHeight: "2.4",
    }),
    option: (base) => ({
      ...base,
      whiteSpace: "normal",
      lineHeight: "1.4",
    }),
    valueContainer: (base) => ({
      ...base,
      alignItems: "flex-start",
    }),
  };

  const getSPLocation = ({
    state = null,
    city = null,
    locality = null,
    type1 = "",
  }: {
    state: string | null;
    city: string | null;
    locality: string | null;
    type1?: string;
  }) => {
    setLoading(true);
    let body = {
      type: type1,
      state: state,
      city: city,
      locality: locality,
      planId: planSelected?.planId,
      serviceId: serviceSelected?.serviceId,
      serviceMode: serviceModeSelected?.modeName,
    };

    const onResponse = (res: any) => {
      if (type1 === "state") {
        setStatesLocs(
          res === null || res.state === null || res.state.length === 0
            ? []
            : res.state.map((e: any) => {
                return {
                  label: e,
                  value: e,
                };
              }),
        );
        setLoading(false);
      } else if (type1 === "city") {
        setCityLocs(
          res === null || res.city === null || res.city.length === 0
            ? []
            : res.city.map((e: any) => {
                return {
                  label: e,
                  value: e,
                };
              }),
        );
        setLoading(false);
      } else if (type1 === "locality") {
        setLocalityLocs(
          res === null || res.locality === null || res.locality.length === 0
            ? []
            : res.locality.map((e: any) => {
                return {
                  label: e,
                  value: e,
                };
              }),
        );
        if (state != null && city != null) {
          getServiceProvider({ state: stateSelected!, city: citySelected! });
        }
      }
    };
    const onError = (err: any) => {
      if (type1 === "state") {
        setStateSelected(null);
        setStatesLocs([]);
        setCitySelected(null);
        setCityLocs([]);
        setLocalitySelected(null);
        setLocalityLocs([]);
      } else if (type1 === "city") {
        setCitySelected(null);
        setCityLocs([]);
        setLocalitySelected(null);
        setLocalityLocs([]);
      } else if (type1 === "locality") {
        setLocalitySelected(null);
        setLocalityLocs([]);
      }
      showNotification({
        title: "Error in fetching service provider location:",
        message: err?.message,
        color: "red",
      });
      if (state != null && city != null) {
        getServiceProvider({ state: stateSelected!, city: citySelected! });
      }
      setLoading(false);
    };
    navigoDashboardUtils.locationFilter(body, onResponse, onError);
  };
  function isAutoSPAllowed(mode: string) {
    return MODES_WITH_AUTO_SP.includes(mode);
  }
  const getAvailableSlots = (date: Date) => {
    setLoading(true);
    let body = {
      planId: planSelected?.planId,
      patientId: Number(patientIdTyped),
      serviceId: serviceSelected?.serviceId,
      serviceProviderId: selectServiceProviderCheckbox
        ? 0
        : serviceProviderSelected?.id == undefined
          ? null
          : serviceProviderSelected.id,
      bookingMode: serviceModeSelected?.modeName,
      collectionDate: dayjs(date).format("YYYY-MM-DD"),
      // addressId: addressSelected == null ? null : addressSelected.id,
      addressId: addressSelected,
      vendor: selectServiceProviderCheckbox
        ? checkAddressServiceableResponse?.vendorId
        : (serviceProviderSelected?.vendorId ?? ""),
      vendorCode: serviceProviderSelected?.vendorCode ?? "",
      vendorDoctorId: serviceProviderSelected?.vendorDoctorId ?? 0,
      providerAddressId:
        serviceProviderSelected?.address?.providerAddressId ?? null,
      memberPatientId: selectedFamilyMember?.memberPatientId ?? 0,
      languageMatch: languagesSelected ?? [],
      locationFilter: stateSelected
        ? buildLocationFilter(stateSelected, citySelected, localitySelected)
        : null,
    };
    const onResponse = (res: any) => {
      if (res != null && res.date === dayjs(date).format("YYYY-MM-DD")) {
        if (res.slots === null) {
          showNotification({
            title: "No slots available",
            message: "",
            color: "red",
          });
        }
        setSlotList(
          res.slots == null
            ? []
            : res.slots.map((e: SlotType) => {
                return {
                  label: intToTime(e.value),
                  value: e,
                };
              }),
        );
        // if (
        //   serviceTypeSelected?.value == 2 &&
        //   serviceModeSelected?.modeName == "Home sample"
        // ) {
        //   setVendor(res.vendorId);
        //   setVendorCode(res.vendorName);
        // } else {
        //   setVendor("");
        //   setVendorCode("");
        // }
        setVendor(res?.vendorId ?? "");
        setVendorCode(res?.vendorName ?? "");
        setVendorDrId(res?.vendorDoctorId ?? 0);
        if (selectServiceProviderCheckbox) {
          setServiceProviderAutoSelected(res.serviceProviderId);
        } else {
          setServiceProviderAutoSelected(null);
        }
        setLoading(false);
      }
    };
    const onError = (err: any) => {
      setSlotSelected(null);
      setServiceProviderAutoSelected(null);
      setVendor("");
      setVendorCode("");
      setVendorDrId(0);
      setSlotList([]);
      showNotification({
        title: "Error in fetching slots:",
        message: err?.message,
        color: "red",
      });
      setLoading(false);
    };
    navigoDashboardUtils.getAvailableSlots(body, onResponse, onError);
  };
  const intToTime = (t: number): string => {
    const hours = Math.floor(t / 60);
    const minutes = t % 60;

    const paddedHours = hours.toString().padStart(2, "0");
    const paddedMinutes = minutes.toString().padStart(2, "0");

    return `${paddedHours}:${paddedMinutes}`;
  };

  const getPatientActiveAcc = () => {
    setLoadingTable(true);
    const onResponse = (res: any) => {
      setAccountsOnPid(
        res == null ||
          res.patientAccounts === null ||
          res.patientAccounts.length == 0
          ? []
          : res.patientAccounts,
      );
      fetchPlansOnPatientId();
    };
    const onError = (err: any) => {
      showNotification({
        title: "Error in fetching patient's active accounts:",
        message: err?.message,
        color: "red",
      });
      setLoadingTable(false);
    };
    navigoDashboardUtils.getPatientActiveAcc(
      patientIdTyped,
      onResponse,
      onError,
    );
  };
  const getFilteredPlans = () => {
    setLoadingTable2(true);
    let body = {
      pageNum: 0,
      pageSize: 0,
      accountCodes: [accountRadioSelected],
      status: 1,
    };
    const onResponse = (res: any) => {
      setPlansOnAccount(
        res === null || res.plans === null || res.plans.length === 0
          ? []
          : res.plans,
      );
      setLoadingTable2(false);
    };
    const onError = (err: any) => {
      setPlansOnAccount([]);
      showNotification({
        title: "Error in fetching plan:",
        message: err?.message,
        color: "red",
      });
      setLoadingTable2(false);
    };
    navigoDashboardUtils.getFilteredPlans(body, onResponse, onError);
  };

  const fetchPlansOnPatientId = () => {
    const onResponse = (res: any) => {
      setLoadingTable(false);
      setPlansOnPid(res == null || res.length == 0 ? [] : res);
    };
    const onError = (err: any) => {
      showNotification({
        title: "Error in fetching patient's plans:",
        message: err?.message,
        color: "red",
      });
      setLoadingTable(false);
    };
    navigoDashboardUtils.getPatientPlans(patientIdTyped, onResponse, onError);
  };
  const isPlanAssignmentValid = () => {
    if (plansSelected.length > 0) {
      assignPlan();
    } else {
      showNotification({
        title: "Please select some plan",
        message: "",
        color: "yellow",
      });
    }
  };
  const assignPlan = () => {
    setLoadingAssignPlan(true);
    setPlansSelected2(plansSelected);
    let body = {
      patientId: Number(patientIdTyped),
      planIds: plansSelected,
    };
    const onResponse = (res: any) => {
      setPlansAssignmentResponse(res == null || res.length == 0 ? [] : res);
      setLoadingAssignPlan(false);
      closeAssignPlanDialog();

      setOpenPlansAssignedDialog(true);
    };
    const onError = (err: any) => {
      showNotification({
        title: "Error in plan assignment:",
        message: err?.message,
        color: "red",
      });
      setLoadingAssignPlan(false);
    };
    navigoDashboardUtils.assignPlan(body, onResponse, onError);
  };
  const saveApp = () => {
    let body: any = {};

    if (isDataValid()) {
      const sendDate = dayjs(dateSelected).format("YYYY-MM-DD");
      const utcMidnight = new Date(sendDate + "T00:00:00Z");
      // save

      if (serviceTypeSelected?.value === 1) {
        body = {
          appointmentDate: utcMidnight,
          bookedFor:
            selectedFamilyMember?.memberPatientId == patientDetails?.id
              ? 0
              : selectedFamilyMember?.memberPatientId,
          patientID: patientDetails?.id,
          serviceID: serviceSelected?.serviceId,
          timeSlot: slotSelected?.value.value,
          timeSlotId: slotSelected?.value.key,
          planID: planSelected?.planId,
          mode: serviceModeSelected?.modeName,
          serviceProviderID: selectServiceProviderCheckbox
            ? serviceProviderAutoSelected
            : serviceProviderSelected?.id,
          isCustomContactNumber: patientContactNumberCheckbox,
          customContactNumber: patientContactNumberCheckbox
            ? {
                countryCode: patientDetails?.countrycode,
                phoneNo: Number(patientContactNumber),
              }
            : {
                countryCode: 0,
                phoneNo: 0,
              },
          reportURL: "",
          reasonId:
            serviceModeSelected?.modeName === "In person consultation"
              ? 0
              : reasonSelected?.id,
          reasonDetails:
            serviceModeSelected?.modeName === "In person consultation"
              ? ""
              : reasonDesc,
          vendorId: vendor,
          vendorCode: vendorCode,
          vendorDoctorId: vendorDrId,
          providerAddressId:
            serviceProviderSelected?.address?.providerAddressId ?? null,
        };

        startPaymentLinkFlow(body);
      } else if (
        serviceTypeSelected?.value === 2 ||
        serviceTypeSelected?.value === 3
      ) {
        body = {
          addressId: addressSelected,
          appointmentDate: utcMidnight,
          bookedFor:
            selectedFamilyMember?.memberPatientId == patientDetails?.id
              ? 0
              : selectedFamilyMember?.memberPatientId,
          patientID: patientDetails?.id,
          serviceID: serviceSelected?.serviceId,
          timeSlot: slotSelected?.value.value,
          timeSlotId: slotSelected?.value.key,
          planID: planSelected?.planId,
          mode: serviceModeSelected?.modeName,
          serviceProviderID: selectServiceProviderCheckbox
            ? serviceProviderAutoSelected
            : serviceProviderSelected?.id,
          reportURL: "",
          vendorId: vendor,
          vendorCode: vendorCode,
          vendorDoctorId: vendorDrId,
          providerAddressId:
            serviceProviderSelected?.address?.providerAddressId ?? "",
        };

        startPaymentLinkFlow(body);
      }
    }
  };
  const isDataValid = () => {
    if (patientIdTyped === "" && (!patientDetails || patientDetails.id < 1)) {
      showNotification({
        title: "Please enter patient id",
        message: "",
        color: "yellow",
      });
      return;
    } else if (!patientDetails || patientDetails.id < 1) {
      showNotification({
        title: "Please enter valid patient details",
        message: "",
        color: "yellow",
      });
      return;
    } else if (accountSelected == null) {
      showNotification({
        title: "Please select an account",
        message: "",
        color: "yellow",
      });
      return;
    } else if (planSelected == null) {
      showNotification({
        title: "Please select a plan",
        message: "",
        color: "yellow",
      });
      return;
    } else if (serviceTypeSelected == null) {
      showNotification({
        title: "Please select a service type",
        message: "",
        color: "yellow",
      });
      return;
    } else if (serviceSelected == null) {
      showNotification({
        title: "Please select a service",
        message: "",
        color: "yellow",
      });
      return;
    } else if (serviceModeSelected == null) {
      showNotification({
        title: "Please select a service mode",
        message: "",
        color: "yellow",
      });
      return;
    } else if (
      selectServiceProviderCheckbox === false &&
      serviceProviderSelected == null
    ) {
      showNotification({
        title: "Please select a service provider",
        message: "",
        color: "yellow",
      });
      return;
    } else if (planSelected == null) {
      showNotification({
        title: "Please select a plan",
        message: "",
        color: "yellow",
      });
      return;
    } else if (selectedFamilyMember == null) {
      showNotification({
        title: "Please select a booking for member",
        message: "",
        color: "yellow",
      });
      return;
    } else if (
      (serviceTypeSelected.value === 2 || serviceTypeSelected.value === 3) &&
      serviceModeSelected != null &&
      serviceModeSelected.modeName === "Home sample" &&
      addressSelected === null
    ) {
      showNotification({
        title: "Please select an address",
        message: "",
        color: "yellow",
      });
      return;
    } else if (dateSelected == null) {
      showNotification({
        title: "Please select an appointment date",
        message: "",
        color: "yellow",
      });
      return;
    } else if (slotSelected == null) {
      showNotification({
        title: "Please select an appointment time slot",
        message: "",
        color: "yellow",
      });
      return;
    } else {
      if (serviceTypeSelected.value === 1) {
        if (
          patientContactNumberCheckbox &&
          patientContactNumber?.length != 10
        ) {
          showNotification({
            title: "Please enter a valid patient contact number",
            message: "",
            color: "yellow",
          });
          return;
        } else if (
          serviceModeSelected.modeName != "In person consultation" &&
          reasonSelected == null
        ) {
          showNotification({
            title: "Please select a reason for consultation",
            message: "",
            color: "yellow",
          });
          return;
        } else if (reasonSelected?.id == 6 && reasonDesc === "") {
          showNotification({
            title: "Please describe the reason",
            message: "",
            color: "yellow",
          });
          return;
        } else {
          return true;
        }
      } else if (
        serviceTypeSelected.value === 2 ||
        serviceTypeSelected.value === 3
      ) {
        return true;
      }
      return false;
    }
  };
  const createAppointment = (body: any) => {
    setLoading(true);
    const onResponse = (res: any) => {
      showNotification({
        title: "Appointment created!",
        message: "",
        color: "green",
      });
      setLoading(false);
      exitPage();
    };
    const onError = (err: any) => {
      showNotification({
        title: "Error in creating appointment:",
        message: err?.message,
        color: "red",
      });
      setLoading(false);
    };
    navigoDashboardUtils.createAppointment(body, onResponse, onError);
  };

  const startPaymentLinkFlow = (body: any) => {
    setPayloadForCreateAppointment(body);
    setShowPaymentLinkDialog(true);
  };

  const getMinDate = (): Date => {
    const baseDate = dayjs().utc().startOf("day");

    if (serviceSelected?.serviceSubTypeId === 3) {
      return baseDate.add(availCareDateMin ?? 0, "day").toDate();
    }

    if (
      serviceModeSelected?.modeName === "Home sample" &&
      !(serviceTypeSelected?.value === 3 && !selectServiceProviderCheckbox)
    ) {
      return baseDate.add(homeSampleDateMin ?? 0, "day").toDate();
    }

    if (selectServiceProviderCheckbox) {
      return baseDate.toDate();
    }

    const minDays = serviceProviderSelected?.minBookingDays ?? 0;
    return baseDate.add(minDays, "day").toDate();
  };

  const getMaxDate = (): Date | undefined => {
    const baseDate = dayjs().utc().startOf("day");

    if (serviceSelected?.serviceSubTypeId === 3) {
      if (availCareDateMax == null) {
        return undefined;
      }

      return baseDate.add(availCareDateMax - 1, "day").toDate();
    }

    if (
      serviceModeSelected?.modeName === "Home sample" &&
      !(serviceTypeSelected?.value === 3 && !selectServiceProviderCheckbox)
    ) {
      if (homeSampleDateMax == null) {
        return undefined;
      }

      return baseDate.add(homeSampleDateMax - 1, "day").toDate();
    }

    if (selectServiceProviderCheckbox) {
      return undefined;
    }

    const maxDays = serviceProviderSelected?.maxBookingDays;

    if (maxDays == null) {
      return undefined;
    }

    return baseDate.add(maxDays - 1, "day").toDate();
  };

  const areDatesAvailable = (): boolean => {
    if (serviceSelected?.serviceSubTypeId === 3) {
      if (availCareDateMin === availCareDateMax) {
        showNotification({
          title: "No date available",
          message: "",
          color: "red",
        });
        return false;
      } else {
        return true;
      }
    }
    // if (
    //   serviceModeSelected?.modeName === "Home sample" &&
    //   !(serviceTypeSelected?.value === 3 && !selectServiceProviderCheckbox)
    // ) {

    //   if (homeSampleDateMin === homeSampleDateMax) {
    //     showNotification({
    //       title: "No date available",
    //       message: "",
    //       color: "red",
    //     });
    //     return false;
    //   } else {
    //     return true;
    //   }
    // }
    if (selectServiceProviderCheckbox) {
      return true;
    }
    const minDays = serviceProviderSelected?.minBookingDays ?? 0;
    const maxDays = serviceProviderSelected?.maxBookingDays ?? 1;
    if (minDays === maxDays) {
      showNotification({
        title: "No date available",
        message: "",
        color: "red",
      });
      return false;
    } else {
      return true;
    }
  };
  const isDatePickerDisabled = (): boolean => {
    const isHomeSampleMode = serviceModeSelected?.modeName === "Home sample";
    if (loading) return true;
    // if (isHomeSampleMode) {
    //   return homeSampleDateMin == null || homeSampleDateMax == null;
    // }
    if (!isHomeSampleMode && !selectServiceProviderCheckbox) {
      return (
        serviceProviderSelected?.minBookingDays == null ||
        serviceProviderSelected?.maxBookingDays == null
      );
    }
    return !areDatesAvailable();
  };
  const getHomeSampleDates = () => {
    const onResponse = (res: any) => {
      if (res != null) {
        setHomeSampleDateMin(res.minBookingDays);
        setHomeSampleDateMax(res.maxAdvBookingDays);
      }
    };
    const onError = (err: any) => {
      setHomeSampleDateMin(null);
      setHomeSampleDateMax(null);
      showNotification({
        title: "Error in fetching dates:",
        message: err?.message,
        color: "red",
      });
    };
    navigoDashboardUtils.getHomeSampleDates(
      Number(patientIdTyped),
      planSelected!.planId,
      onResponse,
      onError,
    );
  };

  const getAvailCareDates = () => {
    const onResponse = (res: any) => {
      if (res != null) {
        setAvailCareDateMin(res.minBookingDays);
        setAvailCareDateMax(res.maxAdvBookingDays);
      }
    };
    const onError = (err: any) => {
      setAvailCareDateMin(null);
      setAvailCareDateMax(null);
      showNotification({
        title: "Error in fetching dates:",
        message: err?.message,
        color: "red",
      });
    };
    navigoDashboardUtils.getAvailCareDates(
      Number(patientIdTyped),
      planSelected!.planId,
      onResponse,
      onError,
    );
  };

  const buildLocationFilter = (
    state?: string | null,
    city?: string | null,
    locality?: string | null,
  ) => {
    if (!state) return [];

    let filter: any = { stateMatch: state };

    if (city) filter.cityMatch = city;
    if (locality) filter.landmarkMatch = locality;

    return [filter];
  };

  const fetchLanguages = (locationFilter: any[] = []) => {
    setLoading(true);
    setLanguagesList([]);
    setLanguagesSelected([]);
    let body = {
      planId: planSelected?.planId,
      serviceId: serviceSelected?.serviceId,
      serviceMode: serviceModeSelected?.modeName,
      locationFilter: locationFilter.length > 0 ? locationFilter : undefined,
    };

    const onResponse = (res: any) => {
      setLanguagesList(
        !res?.languages || res.languages.length === 0 ? [] : res.languages,
      );

      if (!res?.languages || res.languages.length === 0) {
        showNotification({
          title: "No language found",
          message: "",
          color: "yellow",
        });
      }
    };

    const onError = (err: any) => {
      setLanguagesSelected([]);
      setLanguagesList([]);
      showNotification({
        title: "Error in fetching languages:",
        message: err?.message,
        color: "red",
      });
      setLoading(false);
    };

    navigoDashboardUtils.getLanguages(body, onResponse, onError);
  };
  const getPatientAddress = (id: string) => {
    const onResponse = (res: any) => {
      setAddressList(
        res == null || res.length == 0
          ? []
          : res.map((e: AddressType) => {
              return {
                label: `${e.line1}, ${e.line2}, ${
                  e.landmark && e.landmark !== "" ? `${e.landmark}, ` : ""
                }${e.city}, ${e.district}, ${e.state} - ${e.pincode}`,
                value: e,
              };
            }),
      );
    };
    const onError = (err: any) => {
      showNotification({
        title: "Error in fetching address:",
        message: err?.message,
        color: "red",
      });
    };
    navigoDashboardUtils.getPatientAddress(id, onResponse, onError);
  };
  useEffect(() => {
    if (pincode.length === 6) {
      getPincodeData();
    }
  }, [pincode]);
  const getPincodeData = () => {
    const onResponse = (res: any) => {
      if (res != null) {
        if (res.district && res.district !== "") {
          setDistrict(res.district);
        }
        if (res.state && res.state !== "") {
          setState(res.state);
        }
      }
    };
    const onError = (err: any) => {
      setDistrict("");
      setState("");
      showNotification({
        title: "Error in fetching pincode data:",
        message: err?.message,
        color: "yellow",
      });
    };
    navigoDashboardUtils.getPincodeData(pincode, onResponse, onError);
  };
  const exitPage = () => {
    setTotalModes([]);
    setPatientIdTyped("");
    setIsPidSearched(false);
    setPatientDetails(null);
    setRelationsList([]);
    setReasonList([]);
    setReasonSelected(null);
    setReasonDesc("");
    setAccountList([]);
    setAccountSelected(null);
    setFamilyMemberList([]);
    setSelectedFamilyMember(null);
    setPlanList([]);
    setPlanSelected(null);
    setServiceTypeList([]);
    setServiceTypeSelected(null);
    setServiceListToShow([]);
    setServiceSelected(null);
    setServiceModeList([]);
    setServiceModeSelected(null);
    setSelectServiceProviderCheckbox(false);
    setServiceProviderListToShow([]);
    setServiceProviderSelected(null);
    setServiceProviderAutoSelected(null);
    setDateSelected(null);
    setSlotList([]);
    setSlotSelected(null);
    setVendor("");
    setVendorCode("");
    setVendorDrId(0);
    setAddressSelected(null);
    setPatientContactNumber(null);
    setPatientContactNumberCheckbox(false);
    setHomeSampleDateMin(null);
    setHomeSampleDateMax(null);
    setCheckAddressServiceableResponse(null);
    setAddressNotServiceableForPriorityVendors(false);
    setLoading(false);
    navigate("/");
  };

  const closePatientInfoDialog = () => {
    setNewDob(null);
    setNewEmail("");
    setPatientInfo(null);
    setUpdatePatientInfoDialog(false);
  };

  const isDOBEmpty = (patient: PatientInfo | null): boolean => {
    const dob = patient?.dateOfBirth;
    return (
      dob === undefined ||
      dob === null ||
      dob === "" ||
      isNaN(Number(dob)) ||
      Number(dob) === 0
    );
  };

  const isEmailEmpty = (patient: PatientInfo | null): boolean => {
    const email = patient?.email;
    return (
      email === undefined ||
      email === null ||
      typeof email !== "string" ||
      email.trim() === ""
    );
  };

  const isValidEmail = (email: string | null | undefined): boolean => {
    if (
      typeof email !== "string" ||
      email.trim() === "" ||
      !email.includes("@")
    ) {
      return false;
    }

    const [localPart, domain] = email.trim().split("@");

    if (!localPart || !domain) return false;

    const isValidEmailDomain = (domain: string): boolean =>
      /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/.test(domain);

    return isValidEmailDomain(domain);
  };

  const updatePatientInfo = (patient: PatientInfo) => {
    if (isDOBEmpty(patient) && newDob === null) {
      showNotification({
        title: "Please fill the Date of birth",
        message: "",
        color: "yellow",
      });
      return;
    }

    if (isEmailEmpty(patient) && newEmail !== "" && !isValidEmail(newEmail)) {
      showNotification({
        title: "Please enter a valid email address",
        message: "",
        color: "yellow",
      });
      return;
    }

    const body = {
      patientId: patient.patientId,
      firstName: patient.firstName,
      lastName: patient.lastName ? patient.lastName : null,
      gender: patient.gender,
      dateOfBirth: isDOBEmpty(patient)
        ? dayjs(newDob).format("YYYY-MM-DD")
        : dayjs(patient.dateOfBirth).format("YYYY-MM-DD"),

      phoneNo: String(patient.phoneNo),
      email: newEmail !== "" ? newEmail : patient.email,
      profileImage: patient.profileImage,
      countryCode: patient.countryCode,
    };

    const onResponse = (res: any) => {
      if (patientDetails === null) {
        if (newEmail !== "") {
          getPatientDetails(false);
        } else {
          getPatientDetails(true);
        }

        showNotification({
          title: "Patient information updated successfully",
          message: "",
          color: "green",
        });
      } else {
        showNotification({
          title: "Booking for member information updated successfully",
          message: "",
          color: "green",
        });
        if (newEmail !== "") {
          getFamilyDetails(patient.patientId, false);
        } else {
          getFamilyDetails(patient.patientId, true);
        }
      }
      setLoadingProfileUpdate(false);
      closePatientInfoDialog();
    };
    const onError = (err: any) => {
      setSelectedFamilyMember(null);
      showNotification({
        title: "Error in updating profile:",
        message: err?.message,
        color: "red",
      });
      setLoadingProfileUpdate(false);
    };

    if (!isDOBEmpty(patient) && newEmail === "") {
      onResponse("");
    } else {
      setLoadingProfileUpdate(true);
      navigoDashboardUtils.updateProfileInfo(body, onResponse, onError);
    }
  };

  const changeFields = (value: any, name: any) => {
    switch (name) {
      case "district":
        setDistrict(value);
        break;
      case "type":
        setType(value);
        break;
      case "pincode":
        setPincode(value);
        break;
      case "state":
        setState(value);
        break;
      case "city":
        setCity(value);
        break;
      case "line1":
        setLine1(value);
        break;
      case "line2":
        setLine2(value);
        break;
      case "landmark":
        setLandmark(value);
        break;
      case "name":
        setName(value);
        break;
      case "phone":
        if (value.length <= 10) setPhoneNo(value);
        break;
      case "cc":
        setCountryCode(value);
        break;
    }
  };
  const submit = () => {
    let addressBody = {
      city: city.trim(),
      countryCode: parseInt(countryCode),
      district: district.trim(),
      landmark: landmark.trim(),
      line1: line1.trim(),
      line2: line2.trim(),
      name: name.trim(),
      patientId: parseInt(patientIdTyped),
      phoneNo: parseInt(phoneNo.trim()),
      pincode: parseInt(pincode.trim()),
      state: state.trim(),
      type: type,
    };
    as.addPatientAddress(
      addressBody,
      (result: any) => {
        getPatientAddress(patientIdTyped);
        resetFormFields();
        setName(`${patientDetails?.firstName} ${patientDetails?.lastName}`);
        setPhoneNo(`${patientDetails?.phoneno}`);
        showNotification({
          title: "Address added successfully",
          message: "",
          color: "green",
        });
        setIsOpenAddAddress(false);
        console.log(result);
      },
      (error: any) => {
        showNotification({
          title: "Error in saving address",
          message: error?.message ?? "",
          color: "red",
        });
        console.log(error);
      },
    );
  };
  const resetFormFields = () => {
    setDistrict("");
    setPincode("");
    setState("");
    setCity("");
    setLine1("");
    setLine2("");
    setLandmark("");
    setType("");
    setCountryCode("91");
    setErrorFlag(false);
  };
  const isAddressDataValid = () => {
    if (type.trim() === "") {
      showNotification({
        title: "Please fill the type",
        message: "",
        color: "yellow",
      });
      return false;
    }

    if (name.trim() === "") {
      showNotification({
        title: "Please fill the name",
        message: "",
        color: "yellow",
      });
      return false;
    }

    if (phoneNo.trim() === "") {
      showNotification({
        title: "Please fill the phone number",
        message: "",
        color: "yellow",
      });
      return false;
    }

    if (!/^\d{10}$/.test(phoneNo.trim())) {
      showNotification({
        title: "Phone number must be exactly 10 digits",
        message: "",
        color: "yellow",
      });
      return false;
    }

    if (pincode.trim() === "") {
      showNotification({
        title: "Please fill the pincode",
        message: "",
        color: "yellow",
      });
      return false;
    }

    if (!/^\d{6}$/.test(pincode.trim())) {
      showNotification({
        title: "Pincode must be exactly 6 digits",
        message: "",
        color: "yellow",
      });
      return false;
    }

    if (district.trim() === "") {
      showNotification({
        title: "Please fill the district",
        message: "",
        color: "yellow",
      });
      return false;
    }

    if (state.trim() === "") {
      showNotification({
        title: "Please fill the state",
        message: "",
        color: "yellow",
      });
      return false;
    }

    if (city.trim() === "") {
      showNotification({
        title: "Please fill the city",
        message: "",
        color: "yellow",
      });
      return false;
    }

    if (line1.trim() === "") {
      showNotification({
        title: "Please fill the house no/ floor/ building",
        message: "",
        color: "yellow",
      });
      return false;
    }

    if (line2.trim() === "") {
      showNotification({
        title: "Please fill the street/ area",
        message: "",
        color: "yellow",
      });
      return false;
    }

    return true;
  };

  const closeAssignPlanDialog = () => {
    setLoadingTable(false);
    setLoadingTable2(false);
    setAccountsOnPid([]);
    setAccountsOnPid([]);
    setAccountRadioSelected("");
    setPlansSelected([]);
    getPlansForPid(patientIdTyped, accountSelected!);
    setOpenAssignPlanDialog(false);
  };
  const closeAssignPlanResponseDialog = () => {
    setOpenPlansAssignedDialog(false);
    setPlansSelected2([]);
    setPlansAssignmentResponse([]);
    getPlansForPid(patientIdTyped, accountSelected!);
    setPlanSelected(null);
  };
  const isPlanAlreadyAssigned = (planID: number): boolean => {
    return plansOnPid.some((e: any) => e.patientPlanInfo.planId === planID);
  };
  const isPlanSelected = (id: number): boolean => plansSelected.includes(id);
  const handlePlanSelection = (id: number) => {
    setPlansSelected((prevSelected: any) =>
      prevSelected.includes(id)
        ? prevSelected.filter((selectedId: any) => selectedId !== id)
        : [...prevSelected, id],
    );
  };
  function getAgeFromDob(dobMillis: number): string {
    const dob = dayjs(dobMillis);
    const now = dayjs();

    let years = now.diff(dob, "year");
    const adjustedDob = dob.add(years, "year");
    let months = now.diff(adjustedDob, "month");
    // Handle cases where current date is before the day of birth in the month
    if (months < 0) {
      years--;
      months += 12;
    }

    const yearStr = `${years} year${years === 1 ? "" : "s"}`;
    const monthStr =
      months > 0 ? ` ${months} month${months === 1 ? "" : "s"}` : "";

    return `${yearStr}${monthStr}`;
  }

  function getAgeYearFromDob(dob?: string | number | null): string {
    if (!dob) return "-";

    const parsedDob = dayjs(dob);
    if (!parsedDob.isValid()) return "-";

    const now = dayjs();
    const years = now.diff(parsedDob, "year");

    return `${years}`;
  }

  type PatientType = {
    id: number;
    status: number;
    phoneno: number;
    firstName: string;
    lastName: string;
    countrycode: number;
    gender: number;
    dateOfBirth: number;
    email: string;
    profileImage: string;
  };
  type AccountOption = {
    label: string;
    value: string;
  };
  type RelationType = {
    code: number;
    gender: number;
    value: string;
  };
  type FamilyMember = {
    firstName: string;
    lastName: string;
    memberPatientId: number;
    relation: number;
    relationStr: string;
    ageToShow: string;
    gender: number;
  };
  type FamilyMemberOption = {
    label: string;
    value: FamilyMember;
  };
  type PlanType = {
    accountCode: string;
    accountName: string;
    bookConsultation: boolean;
    bookHealthCheckup: boolean;
    bookVaccination: boolean;
    name: string;
    planId: number;
    price: number;
    status: number;
  };
  type PlanTypeOption = {
    label: string;
    value: PlanType;
  };
  type ServiceTypeOption = {
    label: string;
    value: number;
  };
  type ServiceType = {
    addressRequired: boolean;
    description: string;
    descriptionLong: string;
    imageDesktop: string;
    imageMobile: string;
    name: string;
    planId: number;
    serviceCode: string;
    serviceId: number;
    serviceModeDetails: ServiceMode[];
    serviceSubTypeId: number;
    serviceSubTypeName: string;
    serviceTypeId: number;
    serviceTypeName: string;
  };
  type ServiceOption = {
    label: string;
    value: ServiceType;
  };
  type ServiceMode = {
    canAvailService: boolean;
    discountedPrice: number;
    maxPrice: number;
    modeName: string;
    nonServiceAvailabilityReason: string;
    shouldUpdateDetails: boolean;
    hasDifferentialPricing: boolean;
  };
  type ServiceModeOption = {
    label: string;
    value: ServiceMode;
  };
  type ServiceProviderType = {
    address: any;
    // amenities: any;
    // availability: any;
    // desktopCover: string;
    // experience: string;
    id: number;
    // languages: any;
    // licenseNumber: string;
    // longDescription: string;
    maxBookingDays: number;
    minBookingDays: number;
    // mobileCover: string;
    name: string;
    // shortdescription: string;
    margin?: {
      colour?: string;
    };
    vendorId: string;
    vendorCode: string;
    vendorDoctorId: number;
    price: number;
    distanceFromSource?: number;
    amenities?: {
      breakfastAvailable?: boolean;
    };
  };
  type ServiceProviderOption = {
    label: string;
    value: ServiceProviderType;
  };
  type SlotType = {
    key: number;
    value: number;
  };
  type SlotOption = {
    label: string;
    value: SlotType;
  };
  type ReasonType = {
    id: number;
    name: string;
  };
  type ReasonOption = {
    label: string;
    value: ReasonType;
  };
  type AddressOption = {
    label: string;
    value: AddressType;
  };
  type AddressType = {
    id: number;
    patientId: number;
    name: string;
    phoneNo: number;
    line1: string;
    line2: string;
    landmark: string;
    city: string;
    district: string;
    state: string;
    countryCode: number;
    pincode: number;
    type: string;
    isDefault: boolean;
    deleted: boolean;
    coordinates?: AddressCoordinates;
    createdAt?: number;
    updatedAt?: number;
  };
  type LocOption = {
    label: string;
    value: string;
  };
  type PatientInfo = {
    patientId: number;
    firstName: string;
    lastName: string;
    gender: number;
    dateOfBirth: string | number;
    phoneNo: string | number;
    email: string;
    profileImage: string;
    countryCode: number;
  };
  type AccountType = {
    id: string;
    accountName: string;
    accountCode: string;
    status: boolean;
    mode: string;
    managerId: number;
    managerName: string;
    whitelistedDomains: string[];
    logoImage: string;
    tenantId: number;
    patientStatus: boolean;
  };

  // geolocation

  type LatLng = {
    lat: number;
    lng: number;
  };

  interface LocationRangeOption {
    label: string;
    value: number;
  }

  interface LocationModeOption {
    label: string;
    value: string;
  }

  type RangeFilter = {
    latLng: LatLng;
    radius: number; // in KM
    autocheck?: boolean;
  };

  type AddressCoordinates = {
    latitude: number;
    longitude: number;
  };

  type LocationAddress = {
    housing: string;
    coordinates: AddressCoordinates;
    building: string;
    street: string;
    landmark: string;
    neighborhood: string;
    subLocality: string;
    localityArea: string;
    city: string;
    subDistrict: string;
    district: string;
    state: string;
    stateCode: string;
    pincode: string;
    country: string;
    countryCode: string;
  };

  type LocationDialogResult = {
    confirmed: boolean;
    latLng: LatLng;
    address?: LocationAddress;
    selectedLabel?: string;
    query?: string;
  };

  type GeoLocationData = {
    latLng: LatLng;
    address?: LocationAddress | null;
    selectedLabel?: string | null;
    query?: string | null;
  };

  const DEFAULT_NEW_DELHI_LATLNG: LatLng = {
    lat: 28.6139,
    lng: 77.209,
  };

  const { dialogState, setDialogState, openLocationDialog, closeDialog } =
    useLocationDialog();

  // Address edit flow (for addresses without valid coordinates / add new address)
  const {
    dialogState: addrEditDialogState,
    setDialogState: addrEditSetDialogState,
    openLocationDialog: addrEditOpenLocationDialog,
    closeDialog: addrEditCloseDialog,
  } = useLocationDialog();

  const {
    flowState: addrFlowState,
    setFlowState: setAddrFlowState,
    openAddressFlow,
    closeFlow: closeAddrFlow,
  } = useAddressFlow();

  const handleAddressSelectWithValidation = async (
    val: AddressOption | null,
  ) => {
    if (!val?.value) {
      setAddressSelected(null);
      return;
    }
    const v = val.value;
    const hasValidCoordinates =
      v?.coordinates &&
      v.coordinates.latitude !== 0 &&
      v.coordinates.longitude !== 0;

    if (!hasValidCoordinates) {
      let initialLocationData: any = null;
      if (v?.id) {
        try {
          const res = await getCoordinatesFromAddressId(v.id);
          const lat = res?.latitude;
          const lng = res?.longitude;
          if (
            typeof lat === "number" &&
            typeof lng === "number" &&
            !(lat === 0 && lng === 0)
          ) {
            initialLocationData = {
              latLng: { lat, lng },
              address: null,
              selectedLabel: "",
            };
          }
        } catch (e) {
          // ignore — map will open without an initial pin
        }
      }

      const result = await openAddressFlow({
        ...v,
        name: v.name || "",
        phoneNo: String(v.phoneNo || ""),
        pincode: String(v.pincode || ""),
        countryCode: String(v.countryCode || "91"),
        coordinates: v.coordinates || null,
        initialLocationData,
      });

      if (result?.confirmed) {
        // Refresh address list and select the updated address
        getPatientAddress(patientIdTyped);
        setAddressSelected(result.data?.id || null);
      }
    } else {
      setAddressSelected(v.id);
    }
  };

  const handleAddNewAddress = async () => {
    if (selectedFamilyMember === null || loading) return;

    const fullName = [patientDetails?.firstName, patientDetails?.lastName]
      .filter(Boolean)
      .join(" ");

    const result = await openAddressFlow({
      name: fullName || "",
      phoneNo: String(patientDetails?.phoneno || ""),
      type: "Home",
    });

    if (result?.confirmed) {
      getPatientAddress(patientIdTyped);
      setAddressSelected(result.data?.id || null);
    }
  };

  const handleOpenLocationPicker = async (): Promise<void> => {
    // Ensure all properties are undefined instead of null, and omit nulls for type compatibility
    let safeGeoLocData: any = undefined;
    if (geoLocData) {
      const { latLng, address, selectedLabel, query } = geoLocData;
      safeGeoLocData = {
        latLng,
        ...(address ? { address } : {}),
        ...(selectedLabel ? { selectedLabel } : {}),
        ...(query ? { query } : {}),
      };
    }
    const result = await openLocationDialog(safeGeoLocData);

    if (result?.confirmed) {
      const { latLng, address, selectedLabel, query } = result;

      const safeLatLng: LatLng = latLng ?? DEFAULT_NEW_DELHI_LATLNG;

      const dataToStore: GeoLocationData = {
        latLng: safeLatLng,
        address,
        selectedLabel,
        query,
      };

      // reset11
      setGeoLocData(dataToStore);
      // imp to call handleRadiusKmSelected after this will set setRangeOptionSelected(LOCATION_RANGE_KMS_OPTIONS[0]) - not doing it with useEffect
      setTimeout(() => {
        handleRadiusKmSelected(LOCATION_RANGE_KMS_OPTIONS[0], true, safeLatLng);
        if (serviceTypeSelected?.value === 1) {
          fetchLanguages([]);
        }
      }, 0);
    } else {
    }
  };

  function formatAddress(address?: LocationAddress): string {
    if (!address) return "";

    const fieldsInOrder: Array<string | undefined> = [
      address.building,
      address.street,
      address.landmark,
      address.neighborhood,
      address.subLocality,
      address.localityArea,
      address.city,
      address.subDistrict,
      address.district,
      address.state,
      address.pincode,
      address.country,
    ];

    return fieldsInOrder
      .filter(
        (value): value is string =>
          typeof value === "string" && value.trim().length > 0,
      )
      .join(", ");
  }

  function handleRadiusKmSelected(
    rangeOpt: LocationRangeOption | null,
    autocheck: boolean = false,
    latLng: LatLng | null = null,
  ): void {
    const radius = rangeOpt?.value;
    const hasValidRadius = Number.isFinite(radius) && (radius as number) > 0;
    const hasLatLng = latLng?.lat != null && latLng?.lng != null;

    if (!hasValidRadius || !hasLatLng) {
      setRangeOptionSelected(null);
      return;
    }

    setRangeOptionSelected(rangeOpt);
    getServiceProvider({
      range: {
        latLng: latLng,
        radius: radius as number,
        autocheck: Boolean(autocheck),
      },
    });
  }
  const formatDistanceKm = (distanceInMeters?: number): string => {
    if (
      typeof distanceInMeters !== "number" ||
      !Number.isFinite(distanceInMeters)
    )
      return "";

    return `${(distanceInMeters / 1000).toFixed(2)} km away`;
  };

  const getCoordinatesFromAddressId = (
    addressId: number,
  ): Promise<AddressCoordinates | null> => {
    return new Promise((resolve, reject) => {
      const onResponse = (res: AddressCoordinates | null) => {
        resolve(res);
      };

      const onError = (err: any) => {
        showNotification({
          title: "Error in fetching coordinates from address",
          message: err?.message,
          color: "red",
        });
        reject(err);
      };

      navigoDashboardUtils.getCoordinatesFromAddressId(
        addressId,
        onResponse,
        onError,
      );
    });
  };

  const getLocationFromSavedAddress = async (
    addressSelected: AddressType,
  ): Promise<void> => {
    if (!addressSelected) {
      clearGeoLocData3();
      setLoading(false);
      return;
    }

    let lat: number | null = null;
    let lng: number | null = null;

    const coords = addressSelected?.coordinates;

    // Case 1: Coordinates already exist and are valid
    if (
      coords &&
      typeof coords.latitude === "number" &&
      typeof coords.longitude === "number" &&
      !(coords.latitude === 0 && coords.longitude === 0)
    ) {
      lat = coords.latitude;
      lng = coords.longitude;
    }
    // Case 2: Need to fetch from API
    else {
      try {
        const res = await getCoordinatesFromAddressId(addressSelected.id);

        lat = res?.latitude ?? null;
        lng = res?.longitude ?? null;

        if (
          typeof lat !== "number" ||
          typeof lng !== "number" ||
          (lat === 0 && lng === 0)
        ) {
          throw new Error("Invalid coordinates received");
        }
      } catch (error) {
        console.error("Failed to fetch coordinates", error);
        clearGeoLocData3();
        setLoading(false);
        return; // stop execution if error
      }
    }

    const dataToStore = {
      latLng: {
        lat: lat as number,
        lng: lng as number,
      },
      address: null,
      selectedLabel: null,
    };

    setGeoLocData(dataToStore);
    setAddressSelected(addressSelected.id);
    setTimeout(() => {
      handleRadiusKmSelected(
        LOCATION_RANGE_KMS_OPTIONS[0],
        true,
        dataToStore.latLng,
      );

      if (serviceTypeSelected?.value === 1) {
        fetchLanguages([]);
      }
    }, 0);
  };

  return (
    <div className="create-appointment-container">
      {(() => {
        return null;
      })()}
      <div className="ca-heading">
        <Button
          onClick={() => {
            exitPage();
          }}
        >
          <IconArrowLeft width={36} height={36} color="#ef7c01"></IconArrowLeft>
        </Button>
        <div className="text">Create appointment</div>
      </div>
      <br />
      <div className="row-left-margin">
        <Row>
          <Col xs={12} sm={5} md={3} lg={3}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                Patient ID
                <label className="navigo-module-label-red"> *</label>
              </div>
              <Group mt="xs">
                <TextInput
                  placeholder="Patient ID"
                  value={patientIdTyped}
                  onChange={(event) => {
                    const input = event.currentTarget.value;
                    if (input === "" || /^[1-9][0-9]{0,6}$/.test(input)) {
                      setPatientIdTyped(input);
                    }
                  }}
                  // disabled={isPidSearched}
                  disabled
                  styles={{ input: { flex: 1 } }}
                />

                {/* <Button
                  style={{
                    border: "none",
                    borderRadius: "50px",
                    padding: "none",
                    background: "transparent",
                  }}
                  variant="outlined"
                  onClick={handleSearchPatient}
                >
                  {isPidSearched ? (
                    <IconX width={20} height={20} color="#737373"></IconX>
                  ) : (
                    <IconSearch
                      width={20}
                      height={20}
                      color="#ef7c01"
                    ></IconSearch>
                  )}
                </Button> */}
              </Group>
            </div>
          </Col>
        </Row>
      </div>
      <div className="row-left-margin">
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                {`Patient name`}
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div className="small-dropdown">
                <TextInput
                  placeholder=""
                  value={
                    patientDetails == null
                      ? ""
                      : `${patientDetails.firstName} ${patientDetails.lastName}`
                  }
                  disabled
                />
              </div>
            </div>
          </Col>

          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>

          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                {`Patient number`}
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div className="small-dropdown">
                <TextInput
                  placeholder=""
                  value={
                    patientDetails == null
                      ? ""
                      : `+${patientDetails.countrycode}  ${patientDetails.phoneno}`
                  }
                  disabled
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                {`Patient age`}
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div className="small-dropdown">
                <TextInput
                  placeholder=""
                  value={
                    patientDetails == null
                      ? ""
                      : `${getAgeFromDob(patientDetails.dateOfBirth)}`
                  }
                  disabled
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="row-left-margin">
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                {`Date of Birth`}
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div className="small-dropdown">
                <TextInput
                  placeholder=""
                  value={
                    patientDetails?.dateOfBirth
                      ? dayjs(patientDetails.dateOfBirth).format("DD MMM YYYY")
                      : ""
                  }
                  disabled
                />
              </div>
            </div>
          </Col>

          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>

          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                {`Email ID`}
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div className="small-dropdown">
                <TextInput
                  placeholder=""
                  value={patientDetails?.email || ""}
                  disabled
                />
              </div>
            </div>
          </Col>

          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>

          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                {`Gender`}
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div className="small-dropdown">
                <TextInput
                  placeholder=""
                  value={
                    patientDetails?.gender === 1
                      ? "Female"
                      : patientDetails?.gender === 2
                        ? "Male"
                        : ""
                  }
                  disabled
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="row-left-margin">
        <Row>
          <Col xs={12} sm={6} md={6} lg={6}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                Select account
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div className="small-dropdown">
                <SearchDropdown
                  options={accountList}
                  isDisabled={
                    isPidSearched === false || patientIdTyped === "" || loading
                  }
                  value={
                    accountList.find((opt) => opt.value === accountSelected) ||
                    null
                  }
                  blurInputOnSelect
                  placeholder="Select"
                  onChange={(val: AccountOption | null) => {
                    setAccountSelected(val?.value || null);
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="row-left-margin">
        <Row>
          <Col xs={12} sm={6} md={6} lg={6}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                Select plan
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div className="small-dropdown">
                <SearchDropdown
                  options={planList}
                  isDisabled={accountSelected === null || loading}
                  value={
                    planList.find((opt) => opt.value === planSelected) || null
                  }
                  blurInputOnSelect
                  placeholder="Select"
                  onChange={(val: PlanTypeOption | null) => {
                    setPlanSelected(val?.value || null);
                  }}
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={5} md={3} lg={3}>
            <Button
              disabled={accountSelected === null}
              style={
                accountSelected
                  ? {
                      marginTop: "31px",
                      width: "160px",
                      height: "34px",
                      fontSize: "15px",
                      color: "#ffffff",
                      backgroundColor: "#ef7c01",
                      textTransform: "none",
                    }
                  : {
                      marginTop: "31px",
                      width: "160px",
                      height: "34px",
                      fontSize: "15px",
                      color: "#ffffff",
                      backgroundColor: "#c2c2c2",
                      textTransform: "none",
                    }
              }
              onClick={() => {
                if (accountSelected != null) {
                  setOpenAssignPlanDialog(true);
                }
              }}
            >
              Assign new plan
            </Button>
          </Col>
        </Row>
      </div>
      <div className="row-left-margin">
        <Row>
          <Col xs={12} sm={6} md={6} lg={6}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                Select service type
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div className="small-dropdown">
                <SearchDropdown
                  options={serviceTypeList}
                  isDisabled={planSelected === null || loading}
                  value={
                    serviceTypeList.find(
                      (opt) => opt.value === serviceTypeSelected?.value,
                    ) || null
                  }
                  blurInputOnSelect
                  placeholder="Select"
                  onChange={(val: ServiceTypeOption | null) => {
                    setServiceTypeSelected(val || null);
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="row-left-margin">
        <Row>
          <Col xs={12} sm={6} md={6} lg={6}>
            <div className="navigo-module-create-service-field-container">
              <div className="navigo-module-label">
                Booking for
                <label className="navigo-module-label-red"> *</label>
              </div>
              <div className="small-dropdown">
                <SearchDropdown
                  options={familyMemberList}
                  isDisabled={serviceTypeSelected == null || loading}
                  value={
                    familyMemberList.find(
                      (opt) =>
                        opt.value.memberPatientId ===
                        selectedFamilyMember?.memberPatientId,
                    ) || null
                  }
                  blurInputOnSelect
                  placeholder="Select"
                  onChange={(val: FamilyMemberOption | null) => {
                    setSelectedFamilyMember(val?.value || null);
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
      {serviceTypeSelected != null && serviceTypeSelected.value === 1 && (
        <>
          <div className="row-left-margin">
            <Row>
              <Col xs={12} sm={11} md={11} lg={11}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">
                    Select service
                    <label className="navigo-module-label-red"> *</label>
                  </div>
                  <div className="small-dropdown">
                    <SearchDropdown
                      options={serviceListToShow}
                      isDisabled={
                        serviceTypeSelected === null ||
                        selectedFamilyMember == null ||
                        loading
                      }
                      value={
                        serviceListToShow.find(
                          (opt) =>
                            opt.value.serviceId === serviceSelected?.serviceId,
                        ) || null
                      }
                      blurInputOnSelect
                      placeholder="Select"
                      onChange={(val: ServiceOption | null) => {
                        setServiceSelected(val?.value || null);
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <div className="row-left-margin">
            <Row>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">
                    Select service mode
                    <label className="navigo-module-label-red"> *</label>
                  </div>
                  <div className="small-dropdown">
                    <SearchDropdown
                      options={serviceModeList}
                      isDisabled={serviceSelected === null || loading}
                      value={
                        serviceModeList.find(
                          (opt) =>
                            opt.value.modeName ===
                            serviceModeSelected?.modeName,
                        ) || null
                      }
                      blurInputOnSelect
                      placeholder="Select"
                      onChange={(val: ServiceModeOption | null) => {
                        setServiceModeSelected(val?.value || null);
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          {serviceModeSelected != null &&
            serviceModeSelected.modeName === "In person consultation" && (
              <div className="row-left-margin">
                <Row>
                  <Col xs={12} sm={3} md={3} lg={3}>
                    <div className="navigo-module-create-service-field-container">
                      <div className="navigo-module-label">
                        Select location mode
                        <label className="navigo-module-label-red"> *</label>
                      </div>
                      <div className="small-dropdown">
                        <SearchDropdown
                          options={SELECT_LOCATION_MODE_OPTIONS}
                          isDisabled={serviceModeSelected === null || loading}
                          value={
                            SELECT_LOCATION_MODE_OPTIONS.find(
                              (opt) =>
                                opt.value === locationModeSelected?.value,
                            ) || null
                          }
                          blurInputOnSelect
                          placeholder="Select"
                          onChange={(val: LocationModeOption | null) => {
                            setLocationModeSelected(val || null);
                          }}
                        />
                      </div>
                    </div>
                  </Col>
                  {locationModeSelected?.value == LOCATION_MODE.GOOGLE_MAPS && (
                    <>
                      <Col xs={12} sm={1} md={1} lg={1}>
                        <div style={{ height: "20px" }}></div>
                      </Col>
                      <Col xs={12} sm={3} md={3} lg={3}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label"></div>
                          <div className="small-dropdown">
                            <Button
                              disabled={loading}
                              style={
                                !geoLocData?.latLng
                                  ? {
                                      marginTop: "10px",
                                      width: "200px",
                                      height: "40px",
                                      textTransform: "none",

                                      color: "#ffffff",
                                      backgroundColor: "#04C9D3",
                                    }
                                  : {
                                      marginTop: "10px",
                                      width: "200px",
                                      height: "40px",
                                      textTransform: "none",
                                      color: "#ffffff",
                                      backgroundColor: "#ef7c01",
                                    }
                              }
                              onClick={() => {
                                handleOpenLocationPicker();
                              }}
                            >
                              {!geoLocData?.latLng
                                ? "Choose location"
                                : "Change location"}
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </>
                  )}
                </Row>

                {locationModeSelected?.value == LOCATION_MODE.GOOGLE_MAPS &&
                  geoLocData?.latLng !== null && (
                    <>
                      <Col xs={12} sm={11} md={11} lg={11}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">Location</div>
                          <div className="small-dropdown">
                            <TextInput
                              placeholder=""
                              value={
                                formatAddress(
                                  geoLocData?.address ?? undefined,
                                ) ?? ""
                              }
                              disabled
                            />
                          </div>
                        </div>
                      </Col>
                    </>
                  )}

                {locationModeSelected?.value == LOCATION_MODE.MANUAL && (
                  <>
                    <Row>
                      <Col xs={12} sm={5} md={3} lg={3}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">
                            Select state
                            <label className="navigo-module-label-red">
                              {" "}
                              *
                            </label>
                          </div>
                          <div className="small-dropdown">
                            <SearchDropdown
                              options={statesLocs}
                              isDisabled={
                                serviceModeSelected === null || loading
                              }
                              value={
                                statesLocs.find(
                                  (opt) => opt.value === stateSelected,
                                ) || null
                              }
                              blurInputOnSelect
                              placeholder="Select"
                              onChange={(val: LocOption | null) => {
                                setStateSelected(val?.value || null);
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={1} md={1} lg={1}>
                        <div style={{ height: "20px" }}></div>
                      </Col>
                      <Col xs={12} sm={5} md={3} lg={3}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">
                            Select city
                            <label className="navigo-module-label-red">
                              {" "}
                              *
                            </label>
                          </div>
                          <div className="small-dropdown">
                            <SearchDropdown
                              options={cityLocs}
                              isDisabled={stateSelected === null || loading}
                              value={
                                cityLocs.find(
                                  (opt) => opt.value === citySelected,
                                ) || null
                              }
                              blurInputOnSelect
                              placeholder="Select"
                              onChange={(val: LocOption | null) => {
                                setCitySelected(val?.value || null);
                              }}
                            />
                          </div>
                        </div>
                      </Col>

                      <Col xs={12} sm={1} md={1} lg={1}>
                        <div style={{ height: "20px" }}></div>
                      </Col>
                      <Col xs={12} sm={5} md={3} lg={3}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">
                            Select locality
                            {/* <label className="navigo-module-label-red"> *</label> */}
                          </div>
                          <div className="small-dropdown">
                            <SearchDropdown
                              options={localityLocs}
                              isDisabled={citySelected === null || loading}
                              value={
                                localityLocs.find(
                                  (opt) => opt.value === localitySelected,
                                ) || null
                              }
                              blurInputOnSelect
                              placeholder="Select"
                              onChange={(val: LocOption | null) => {
                                setLocalitySelected(val?.value || null);
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}

                {locationModeSelected?.value == LOCATION_MODE.SAVED_ADDRESSES &&
                  geoLocData?.latLng !== null && (
                    <>
                      <Col xs={12} sm={6} md={6} lg={6}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">
                            Select address
                            <label className="navigo-module-label-red">
                              {" "}
                              *
                            </label>
                          </div>
                          <div className="small-dropdown">
                            <SearchDropdown
                              options={addressList}
                              isDisabled={loading}
                              value={
                                addressList.find(
                                  (opt) => opt.value?.id === addressSelected,
                                ) || null
                              }
                              blurInputOnSelect
                              placeholder="Select"
                              onChange={(val: AddressOption | null) => {
                                if (val) {
                                  setLoading(true);
                                  getLocationFromSavedAddress(val?.value);
                                } else {
                                  setAddressSelected(null);
                                  clearGeoLocData3();
                                }
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                    </>
                  )}
              </div>
            )}
          <div className="row-left-margin">
            {(locationModeSelected?.value == LOCATION_MODE.GOOGLE_MAPS ||
              locationModeSelected?.value == LOCATION_MODE.SAVED_ADDRESSES) &&
              geoLocData?.latLng !== null && (
                <>
                  <Row>
                    <Col xs={12} sm={3} md={3} lg={3}>
                      <div className="navigo-module-create-service-field-container">
                        <div className="navigo-module-label">
                          Area radius
                          <label className="navigo-module-label-red"> *</label>
                        </div>
                        <div className="small-dropdown">
                          <SearchDropdown
                            options={LOCATION_RANGE_KMS_OPTIONS}
                            isDisabled={
                              loading ||
                              geoLocData?.latLng == null ||
                              (addressSelected == null &&
                                locationModeSelected?.value ==
                                  LOCATION_MODE.SAVED_ADDRESSES)
                            }
                            value={
                              LOCATION_RANGE_KMS_OPTIONS.find(
                                (opt) =>
                                  opt.value === rangeOptionSelected?.value,
                              ) || null
                            }
                            blurInputOnSelect
                            placeholder="Select"
                            onChange={(val: LocationRangeOption | null) => {
                              handleRadiusKmSelected(
                                val,
                                false,
                                geoLocData?.latLng || null,
                              );
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </>
              )}
            <Row>
              <Col xs={12} sm={5} md={3} lg={3}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">Language</div>
                  <div className="small-dropdown">
                    <MultiSelect
                      placeholder="Type here"
                      disabled={
                        serviceModeSelected === null ||
                        (serviceModeSelected.modeName ===
                          "In person consultation" &&
                          (stateSelected == null || citySelected == null) &&
                          !rangeOptionSelected)
                      }
                      readOnly={loading}
                      searchable
                      clearable
                      data={languagesList}
                      value={languagesSelected}
                      onChange={(values) => {
                        setLanguagesSelected(values);

                        if (values?.length === 0) {
                          if (serviceModeSelected != null) {
                            if (
                              (locationModeSelected?.value ==
                                LOCATION_MODE.GOOGLE_MAPS ||
                                locationModeSelected?.value ==
                                  LOCATION_MODE.SAVED_ADDRESSES) &&
                              geoLocData?.latLng != null &&
                              rangeOptionSelected != null
                            ) {
                              getServiceProvider({
                                range: {
                                  latLng: geoLocData?.latLng,
                                  radius: rangeOptionSelected?.value,
                                  autocheck: false,
                                },
                              });
                              // } else if (
                              //   locationModeSelected?.value ==
                              //   LOCATION_MODE.MANUAL
                              // ) {
                            } else {
                              getServiceProvider({
                                state: stateSelected!,
                                city: citySelected!,
                                locality: localitySelected!,
                              });
                            }
                          }
                          setSelectServiceProviderCheckbox(false);
                          setServiceProviderSelected(null);
                          setServiceProviderListToShow([]);
                        }
                        setDateSelected(null);
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <div className="row-left-margin">
            <Row>
              <Col xs={12} sm={11} md={11} lg={11}>
                <div className="navigo-module-create-service-field-container">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "10px",
                      marginBottom: "-14px",
                    }}
                  >
                    <div>
                      <Checkbox
                        size="sm"
                        color="green"
                        disabled={
                          serviceModeSelected === null ||
                          !isAutoSPAllowed(serviceModeSelected?.modeName) ||
                          loading ||
                          (serviceModeSelected.modeName ===
                            "In person consultation" &&
                            (stateSelected == null || citySelected == null) &&
                            !rangeOptionSelected)
                        }
                        checked={selectServiceProviderCheckbox}
                        onChange={(event) =>
                          setSelectServiceProviderCheckbox(
                            !selectServiceProviderCheckbox,
                          )
                        }
                      />
                    </div>
                    <div className="navigo-module-label-overflow">
                      Select service provider or check mark to select
                      automatically
                      <label className="navigo-module-label-red"> *</label>
                    </div>
                  </div>

                  <div className="small-dropdown">
                    <SearchDropdown
                      options={serviceProviderListToShow}
                      styles={selectStyles}
                      isDisabled={
                        serviceModeSelected === null ||
                        selectServiceProviderCheckbox ||
                        loading ||
                        (serviceModeSelected.modeName ===
                          "In person consultation" &&
                          (stateSelected == null || citySelected == null) &&
                          !rangeOptionSelected)
                      }
                      value={
                        serviceProviderListToShow.find(
                          (opt) =>
                            opt.value.id === serviceProviderSelected?.id &&
                            (serviceProviderSelected?.vendorDoctorId == null ||
                              opt.value.vendorDoctorId ===
                                serviceProviderSelected.vendorDoctorId),
                        ) || null
                      }
                      blurInputOnSelect
                      placeholder={
                        selectServiceProviderCheckbox
                          ? "Not required"
                          : "Select"
                      }
                      onChange={(val: ServiceProviderOption | null) => {
                        setServiceProviderSelected(val?.value || null);
                      }}
                      formatOptionLabel={(option) => (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {option?.value?.margin?.colour ? (
                            <span
                              style={{
                                width: 12,
                                height: 12,
                                borderRadius: "50%",
                                backgroundColor: option.value.margin.colour,
                                marginRight: 8,
                              }}
                            />
                          ) : null}
                          <span>{option.label}</span>
                        </div>
                      )}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          {(locationModeSelected?.value == LOCATION_MODE.GOOGLE_MAPS ||
            locationModeSelected?.value == LOCATION_MODE.SAVED_ADDRESSES) &&
            serviceProviderSelected && (
              <>
                <div className="row-left-margin">
                  <Row>
                    <Col xs={12} sm={3} md={3} lg={3}>
                      <div className="navigo-module-create-service-field-container">
                        <div className="navigo-module-label">
                          Distance from location provider
                        </div>
                        <div className="small-dropdown">
                          <TextInput
                            placeholder=""
                            value={formatDistanceKm(
                              serviceProviderSelected?.distanceFromSource,
                            )}
                            disabled
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </>
            )}
          {serviceProviderSelected &&
            serviceProviderSelected?.amenities?.breakfastAvailable == true && (
              <div className="row-left-margin">
                <Row>
                  <Col xs={12} sm={11} md={11} lg={11}>
                    <div className="navigo-module-create-service-field-container">
                      <div
                        style={{
                          width: "fit-content",
                          backgroundColor: "#EBEBFC",
                          borderRadius: "10px",
                          padding: "4px 10px",
                          fontSize: "12px",
                        }}
                      >
                        Breakfast available
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          {serviceModeSelected != null &&
            serviceModeSelected.modeName === "In person consultation" && (
              <div className="row-left-margin">
                <Row>
                  <Col xs={12} sm={6} md={6} lg={6}>
                    <div className="navigo-module-create-service-field-container">
                      <div className="navigo-module-label">
                        {`Google map link`}
                        <label className="navigo-module-label-red"> *</label>
                      </div>
                      <div className="small-dropdown">
                        <TextInput
                          placeholder=""
                          value={
                            serviceProviderSelected?.address?.googleMapLink ||
                            ""
                          }
                          disabled
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          <div className="row-left-margin">
            <Row>
              <Col xs={12} sm={5} md={3} lg={3}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">
                    Choose date
                    <label className="navigo-module-label-red"> *</label>
                  </div>
                  <div className="small-dropdown">
                    <DatePicker
                      key={
                        dateSelected == null
                          ? "reset-datepicker"
                          : "active-datepicker"
                      }
                      weekendDays={[]}
                      dropdownPosition="bottom-start"
                      placeholder="Choose a date"
                      clearable={false}
                      value={dateSelected}
                      disabled={isDatePickerDisabled()}
                      onChange={(val) => {
                        if (val)
                          setDateSelected(dayjs(val).startOf("day").toDate());
                      }}
                      minDate={getMinDate()}
                      maxDate={getMaxDate()}
                    />
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={1} md={1} lg={1}>
                <div style={{ height: "20px" }}></div>
              </Col>

              <Col xs={12} sm={3} md={2} lg={2}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">
                    Choose timeslot
                    <label className="navigo-module-label-red"> *</label>
                  </div>
                  <div className="small-dropdown">
                    <SearchDropdown
                      options={slotList}
                      isDisabled={dateSelected === null || loading}
                      value={slotSelected}
                      blurInputOnSelect
                      placeholder="Select"
                      onChange={(val: SlotOption | null) => {
                        setSlotSelected(val);
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          {serviceModeSelected != null &&
            serviceModeSelected.modeName != "In person consultation" && (
              <>
                <div className="row-left-margin">
                  <Row>
                    <Col xs={12} sm={6} md={6} lg={6}>
                      <div className="navigo-module-create-service-field-container">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            marginTop: "10px",
                            marginBottom: "-14px",
                          }}
                        >
                          <div>
                            <Checkbox
                              size="sm"
                              color="green"
                              disabled={
                                serviceTypeSelected === null ||
                                serviceTypeSelected.value != 1 ||
                                loading
                              }
                              checked={patientContactNumberCheckbox}
                              onChange={(event) =>
                                setPatientContactNumberCheckbox(
                                  !patientContactNumberCheckbox,
                                )
                              }
                            />
                          </div>
                          <div className="navigo-module-label-overflow">
                            Patient contact number
                            <label className="navigo-module-label-red">
                              {" "}
                              *
                            </label>
                          </div>
                        </div>

                        <div className="small-dropdown-2">
                          <TextInput
                            placeholder=""
                            value={
                              patientDetails == null
                                ? ""
                                : `+${patientDetails.countrycode}`
                            }
                            style={{ width: "55px", marginRight: "12px" }}
                            disabled
                          />
                          <TextInput
                            placeholder=""
                            value={patientContactNumber ?? ""}
                            disabled={
                              patientContactNumber == null ||
                              patientContactNumberCheckbox === false ||
                              loading
                            }
                            onChange={(e) => {
                              const input = e.currentTarget.value;
                              const digitsOnly = input
                                .replace(/\D/g, "")
                                .slice(0, 10);
                              setPatientContactNumber(digitsOnly);
                            }}
                            maxLength={10}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="row-left-margin">
                  <Row>
                    <Col xs={12} sm={6} md={6} lg={6}>
                      <div className="navigo-module-create-service-field-container">
                        <div className="navigo-module-label">
                          Reason for consultation
                          <label className="navigo-module-label-red"> *</label>
                        </div>
                        <div className="small-dropdown">
                          <SearchDropdown
                            options={reasonList}
                            isDisabled={
                              serviceTypeSelected === null ||
                              serviceTypeSelected.value != 1 ||
                              loading
                            }
                            value={
                              reasonList.find(
                                (opt) => opt.value.id === reasonSelected?.id,
                              ) || null
                            }
                            blurInputOnSelect
                            placeholder="Select"
                            onChange={(val: ReasonOption | null) => {
                              setReasonSelected(val?.value || null);
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="row-left-margin">
                  <Row>
                    <Col xs={12} sm={9} md={9} lg={9}>
                      <div className="navigo-module-create-service-field-container">
                        <div className="navigo-module-label">
                          {`Describe the reason (mandatory only if "other" is selected in Reason for consultation field)`}
                          {/* <label className="navigo-module-label-red"> *</label> */}
                        </div>
                        <div className="small-dropdown">
                          <TextInput
                            placeholder="Type here"
                            value={reasonDesc}
                            disabled={
                              serviceTypeSelected === null ||
                              serviceTypeSelected.value != 1 ||
                              loading
                            }
                            onChange={(e) => {
                              setReasonDesc(e.currentTarget.value);
                            }}
                            maxLength={1000}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </>
            )}
        </>
      )}
      {serviceTypeSelected != null &&
        (serviceTypeSelected.value === 2 ||
          serviceTypeSelected.value === 3) && (
          <>
            <div className="row-left-margin">
              <Row>
                <Col xs={12} sm={11} md={11} lg={11}>
                  <div className="navigo-module-create-service-field-container">
                    <div className="navigo-module-label">
                      Select service
                      <label className="navigo-module-label-red"> *</label>
                    </div>
                    <div className="small-dropdown">
                      <SearchDropdown
                        options={serviceListToShow}
                        isDisabled={
                          serviceTypeSelected === null ||
                          selectedFamilyMember == null ||
                          loading
                        }
                        value={
                          serviceListToShow.find(
                            (opt) =>
                              opt.value.serviceId ===
                              serviceSelected?.serviceId,
                          ) || null
                        }
                        blurInputOnSelect
                        placeholder="Select"
                        onChange={(val: ServiceOption | null) => {
                          setServiceSelected(val?.value || null);
                        }}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="row-left-margin">
              <Row>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <div className="navigo-module-create-service-field-container">
                    <div className="navigo-module-label">
                      Select service mode
                      <label className="navigo-module-label-red"> *</label>
                    </div>
                    <div className="small-dropdown">
                      <SearchDropdown
                        options={serviceModeList}
                        isDisabled={serviceSelected === null || loading}
                        value={
                          serviceModeList.find(
                            (opt) =>
                              opt.value.modeName ===
                              serviceModeSelected?.modeName,
                          ) || null
                        }
                        blurInputOnSelect
                        placeholder="Select"
                        onChange={(val: ServiceModeOption | null) => {
                          setServiceModeSelected(val?.value || null);
                        }}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            {serviceModeSelected != null &&
              (serviceModeSelected.modeName === "Centre visit" ||
                serviceModeSelected.modeName === "Camp site visit") && (
                <div className="row-left-margin">
                  <Row>
                    <Col xs={12} sm={3} md={3} lg={3}>
                      <div className="navigo-module-create-service-field-container">
                        <div className="navigo-module-label">
                          Select location mode
                          <label className="navigo-module-label-red"> *</label>
                        </div>
                        <div className="small-dropdown">
                          <SearchDropdown
                            options={SELECT_LOCATION_MODE_OPTIONS}
                            isDisabled={serviceModeSelected === null || loading}
                            value={
                              SELECT_LOCATION_MODE_OPTIONS.find(
                                (opt) =>
                                  opt.value === locationModeSelected?.value,
                              ) || null
                            }
                            blurInputOnSelect
                            placeholder="Select"
                            onChange={(val: LocationModeOption | null) => {
                              setLocationModeSelected(val || null);
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                    {locationModeSelected?.value ==
                      LOCATION_MODE.GOOGLE_MAPS && (
                      <>
                        <Col xs={12} sm={1} md={1} lg={1}>
                          <div style={{ height: "20px" }}></div>
                        </Col>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="navigo-module-create-service-field-container">
                            <div className="navigo-module-label"></div>
                            <div className="small-dropdown">
                              <Button
                                disabled={loading}
                                style={
                                  !geoLocData?.latLng
                                    ? {
                                        marginTop: "10px",
                                        width: "200px",
                                        height: "40px",
                                        textTransform: "none",
                                        color: "#ffffff",
                                        backgroundColor: "#04C9D3",
                                      }
                                    : {
                                        marginTop: "10px",
                                        width: "200px",
                                        height: "40px",
                                        textTransform: "none",
                                        color: "#ffffff",
                                        backgroundColor: "#ef7c01",
                                      }
                                }
                                onClick={() => {
                                  handleOpenLocationPicker();
                                }}
                              >
                                {!geoLocData?.latLng
                                  ? "Choose location"
                                  : "Change location"}
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </>
                    )}
                  </Row>

                  {locationModeSelected?.value == LOCATION_MODE.MANUAL && (
                    <>
                      {" "}
                      <Row>
                        <Col xs={12} sm={5} md={3} lg={3}>
                          <div className="navigo-module-create-service-field-container">
                            <div className="navigo-module-label">
                              Select state
                              <label className="navigo-module-label-red">
                                {" "}
                                *
                              </label>
                            </div>
                            <div className="small-dropdown">
                              <SearchDropdown
                                options={statesLocs}
                                isDisabled={
                                  serviceModeSelected === null || loading
                                }
                                value={
                                  statesLocs.find(
                                    (opt) => opt.value === stateSelected,
                                  ) || null
                                }
                                blurInputOnSelect
                                placeholder="Select"
                                onChange={(val: LocOption | null) => {
                                  setStateSelected(val?.value || null);
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={1} md={1} lg={1}>
                          <div style={{ height: "20px" }}></div>
                        </Col>
                        <Col xs={12} sm={5} md={3} lg={3}>
                          <div className="navigo-module-create-service-field-container">
                            <div className="navigo-module-label">
                              Select city
                              <label className="navigo-module-label-red">
                                {" "}
                                *
                              </label>
                            </div>
                            <div className="small-dropdown">
                              <SearchDropdown
                                options={cityLocs}
                                isDisabled={stateSelected === null || loading}
                                value={
                                  cityLocs.find(
                                    (opt) => opt.value === citySelected,
                                  ) || null
                                }
                                blurInputOnSelect
                                placeholder="Select"
                                onChange={(val: LocOption | null) => {
                                  setCitySelected(val?.value || null);
                                }}
                              />
                            </div>
                          </div>
                        </Col>

                        <Col xs={12} sm={1} md={1} lg={1}>
                          <div style={{ height: "20px" }}></div>
                        </Col>
                        <Col xs={12} sm={5} md={3} lg={3}>
                          <div className="navigo-module-create-service-field-container">
                            <div className="navigo-module-label">
                              Select locality
                              {/* <label className="navigo-module-label-red"> *</label> */}
                            </div>
                            <div className="small-dropdown">
                              <SearchDropdown
                                options={localityLocs}
                                isDisabled={citySelected === null || loading}
                                value={
                                  localityLocs.find(
                                    (opt) => opt.value === localitySelected,
                                  ) || null
                                }
                                blurInputOnSelect
                                placeholder="Select"
                                onChange={(val: LocOption | null) => {
                                  setLocalitySelected(val?.value || null);
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </>
                  )}

                  {locationModeSelected?.value ==
                    LOCATION_MODE.SAVED_ADDRESSES &&
                    geoLocData?.latLng !== null && (
                      <>
                        <Col xs={12} sm={6} md={6} lg={6}>
                          <div className="navigo-module-create-service-field-container">
                            <div className="navigo-module-label">
                              Select address
                              <label className="navigo-module-label-red">
                                {" "}
                                *
                              </label>
                            </div>
                            <div className="small-dropdown">
                              <SearchDropdown
                                options={addressList}
                                isDisabled={loading}
                                value={
                                  addressList.find(
                                    (opt) => opt.value?.id === addressSelected,
                                  ) || null
                                }
                                blurInputOnSelect
                                placeholder="Select"
                                onChange={(val: AddressOption | null) => {
                                  if (val) {
                                    setLoading(true);
                                    getLocationFromSavedAddress(val?.value);
                                  } else {
                                    setAddressSelected(null);
                                    clearGeoLocData3();
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                      </>
                    )}
                </div>
              )}

            {(locationModeSelected?.value == LOCATION_MODE.GOOGLE_MAPS ||
              locationModeSelected?.value == LOCATION_MODE.SAVED_ADDRESSES) &&
              geoLocData?.latLng !== null && (
                <>
                  {" "}
                  <div className="row-left-margin">
                    <Row>
                      <Col xs={12} sm={3} md={3} lg={3}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">
                            Area radius
                            <label className="navigo-module-label-red">
                              {" "}
                              *
                            </label>
                          </div>
                          <div className="small-dropdown">
                            <SearchDropdown
                              options={LOCATION_RANGE_KMS_OPTIONS}
                              isDisabled={
                                loading ||
                                geoLocData?.latLng == null ||
                                (addressSelected == null &&
                                  locationModeSelected?.value ==
                                    LOCATION_MODE.SAVED_ADDRESSES)
                              }
                              value={
                                LOCATION_RANGE_KMS_OPTIONS.find(
                                  (opt) =>
                                    opt.value === rangeOptionSelected?.value,
                                ) || null
                              }
                              blurInputOnSelect
                              placeholder="Select"
                              onChange={(val: LocationRangeOption | null) => {
                                handleRadiusKmSelected(
                                  val,
                                  false,
                                  geoLocData?.latLng || null,
                                );
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </>
              )}

            {serviceModeSelected != null &&
              serviceModeSelected.modeName === "Home sample" && (
                <div className="row-left-margin">
                  <Row>
                    <Col xs={12} sm={6} md={6} lg={6}>
                      <div className="navigo-module-create-service-field-container">
                        <div className="navigo-module-label">
                          Select address
                          <label className="navigo-module-label-red"> *</label>
                        </div>
                        <div className="small-dropdown">
                          <SearchDropdown
                            options={addressList}
                            isDisabled={loading}
                            value={
                              addressList.find(
                                (opt) => opt.value?.id === addressSelected,
                              ) || null
                            }
                            blurInputOnSelect
                            placeholder="Select"
                            onChange={(val: AddressOption | null) => {
                              handleAddressSelectWithValidation(val);
                            }}
                            formatOptionLabel={(option) => {
                              const coords = option?.value?.coordinates;

                              const hasValidCoordinates =
                                coords &&
                                coords.latitude !== 0 &&
                                coords.longitude !== 0;

                              return (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {!hasValidCoordinates && (
                                    <div
                                      style={{
                                        backgroundColor: "#E9E7FE",
                                        color: "#6A5FF5",
                                        fontSize: 10,
                                        padding: "2px 6px",
                                        borderRadius: 6,
                                        marginRight: 8,
                                        fontWeight: 600,
                                      }}
                                    >
                                      Update
                                    </div>
                                  )}

                                  <span>{option.label}</span>
                                </div>
                              );
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} sm={1} md={1} lg={1}>
                      <div style={{ height: "20px" }}></div>
                    </Col>
                    <Col xs={12} sm={4} md={2} lg={2}>
                      <div style={{ marginTop: "28px" }}>
                        <a
                          className="address-header-button"
                          style={{
                            color:
                              selectedFamilyMember === null || loading
                                ? "#e2c2c2"
                                : "#ef7c01",
                            cursor:
                              selectedFamilyMember === null || loading
                                ? "default"
                                : "pointer",
                          }}
                          onClick={() => {
                            if (selectedFamilyMember === null || loading) {
                            } else {
                              handleAddNewAddress();
                            }
                          }}
                        >
                          + Add Address
                        </a>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            <div className="row-left-margin">
              <Row>
                <Col xs={12} sm={11} md={11} lg={11}>
                  <div className="navigo-module-create-service-field-container">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "10px",
                        marginBottom: "-14px",
                      }}
                    >
                      <div>
                        <Checkbox
                          size="sm"
                          color="green"
                          disabled={
                            loading ||
                            (serviceModeSelected != null &&
                              (serviceModeSelected.modeName ===
                                "Centre visit" ||
                                serviceModeSelected.modeName ===
                                  "Camp site visit") &&
                              citySelected === null &&
                              !rangeOptionSelected) ||
                            serviceModeSelected === null ||
                            !isAutoSPAllowed(serviceModeSelected?.modeName) ||
                            (serviceModeSelected.modeName === "Home sample" &&
                              addressSelected == null)
                          }
                          checked={selectServiceProviderCheckbox}
                          onChange={(event) =>
                            setSelectServiceProviderCheckbox(
                              !selectServiceProviderCheckbox,
                            )
                          }
                        />
                      </div>
                      <div className="navigo-module-label-overflow">
                        Select service provider or check mark to select
                        automatically
                        <label className="navigo-module-label-red"> *</label>
                      </div>
                    </div>

                    <div className="small-dropdown">
                      <SearchDropdown
                        options={serviceProviderListToShow.filter(
                          (opt) =>
                            !(
                              addressNotServiceableForPriorityVendors &&
                              priorityVendorMappedSpIds.includes(opt.value.id)
                            ),
                        )}
                        styles={selectStyles}
                        isDisabled={
                          loading ||
                          (serviceModeSelected != null &&
                            (serviceModeSelected.modeName === "Centre visit" ||
                              serviceModeSelected.modeName ===
                                "Camp site visit") &&
                            citySelected === null &&
                            !rangeOptionSelected) ||
                          serviceModeSelected === null ||
                          selectServiceProviderCheckbox ||
                          (serviceModeSelected.modeName === "Home sample" &&
                            addressSelected == null)
                        }
                        value={
                          serviceProviderListToShow.find(
                            (opt) =>
                              opt.value.id === serviceProviderSelected?.id,
                          ) || null
                        }
                        blurInputOnSelect
                        placeholder={
                          selectServiceProviderCheckbox
                            ? "Not required"
                            : "Select"
                        }
                        onChange={(val: ServiceProviderOption | null) => {
                          setServiceProviderSelected(val?.value || null);
                        }}
                        formatOptionLabel={(option) => (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {option?.value?.margin?.colour ? (
                              <span
                                style={{
                                  width: 12,
                                  height: 12,
                                  borderRadius: "50%",
                                  backgroundColor: option.value.margin.colour,
                                  marginRight: 8,
                                }}
                              />
                            ) : null}
                            <span>{option.label}</span>
                          </div>
                        )}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            {(locationModeSelected?.value == LOCATION_MODE.GOOGLE_MAPS ||
              locationModeSelected?.value == LOCATION_MODE.SAVED_ADDRESSES) &&
              serviceProviderSelected && (
                <>
                  <div className="row-left-margin">
                    <Row>
                      <Col xs={12} sm={3} md={3} lg={3}>
                        <div className="navigo-module-create-service-field-container">
                          <div className="navigo-module-label">
                            Distance from location provider
                          </div>
                          <div className="small-dropdown">
                            <TextInput
                              placeholder=""
                              value={formatDistanceKm(
                                serviceProviderSelected?.distanceFromSource,
                              )}
                              disabled
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </>
              )}
            {serviceProviderSelected &&
              serviceProviderSelected?.amenities?.breakfastAvailable ==
                true && (
                <div className="row-left-margin">
                  <Row>
                    <Col xs={12} sm={11} md={11} lg={11}>
                      <div className="navigo-module-create-service-field-container">
                        <div
                          style={{
                            width: "fit-content",
                            backgroundColor: "#EBEBFC",
                            borderRadius: "10px",
                            padding: "4px 10px",
                            fontSize: "12px",
                          }}
                        >
                          Breakfast available
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            {serviceModeSelected != null &&
              (serviceModeSelected.modeName === "Centre visit" ||
                serviceModeSelected.modeName === "Camp site visit") && (
                <div className="row-left-margin">
                  <Row>
                    <Col xs={12} sm={6} md={6} lg={6}>
                      <div className="navigo-module-create-service-field-container">
                        <div className="navigo-module-label">
                          {`Google map link`}
                          <label className="navigo-module-label-red"> *</label>
                        </div>
                        <div className="small-dropdown">
                          <TextInput
                            placeholder=""
                            value={
                              serviceProviderSelected?.address?.googleMapLink ||
                              ""
                            }
                            disabled
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}

            <div className="row-left-margin">
              <Row>
                <Col xs={12} sm={5} md={3} lg={3}>
                  <div className="navigo-module-create-service-field-container">
                    <div className="navigo-module-label">
                      Choose date
                      <label className="navigo-module-label-red"> *</label>
                    </div>
                    <div className="small-dropdown">
                      <DatePicker
                        key={
                          dateSelected == null
                            ? "reset-datepicker-2"
                            : "active-datepicker-2"
                        }
                        weekendDays={[]}
                        dropdownPosition="bottom-start"
                        placeholder="Choose a date"
                        clearable={false}
                        value={dateSelected}
                        disabled={
                          isDatePickerDisabled() ||
                          (serviceModeSelected?.modeName === "Home sample" &&
                            addressSelected == null)
                        }
                        onChange={(val) => {
                          if (val)
                            setDateSelected(dayjs(val).startOf("day").toDate());
                        }}
                        minDate={getMinDate()}
                        maxDate={getMaxDate()}
                      />
                    </div>
                  </div>
                </Col>

                <Col xs={12} sm={1} md={1} lg={1}>
                  <div style={{ height: "20px" }}></div>
                </Col>

                <Col xs={12} sm={3} md={2} lg={2}>
                  <div className="navigo-module-create-service-field-container">
                    <div className="navigo-module-label">
                      Choose timeslot
                      <label className="navigo-module-label-red"> *</label>
                    </div>
                    <div className="small-dropdown">
                      <SearchDropdown
                        options={slotList}
                        isDisabled={dateSelected === null || loading}
                        value={slotSelected}
                        blurInputOnSelect
                        placeholder="Select"
                        onChange={(val: SlotOption | null) => {
                          setSlotSelected(val);
                        }}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </>
        )}

      {aptPrice != null && typeof aptPrice === "number" && aptPrice >= 0 && (
        <>
          <div className="row-left-margin">
            <Row>
              <Col xs={12} sm={5} md={3} lg={3}>
                <div className="navigo-module-create-service-field-container">
                  <div className="navigo-module-label">{`Total amount`}</div>
                  <div className="small-dropdown">
                    <TextInput
                      placeholder=""
                      value={`Rs ${aptPrice}`}
                      disabled
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </>
      )}
      <br />
      {
        <div className="row-left-margin">
          <Row>
            <Col xs={12} sm={5} md={5} lg={5}>
              <Button
                className={loading ? "zy-btn-orange disabled" : "zy-btn-orange"}
                disabled={loading}
                onClick={() => {
                  saveApp();
                }}
              >
                {aptPrice != null &&
                typeof aptPrice === "number" &&
                aptPrice > 0
                  ? "Create appointment & proceed to pay"
                  : "Create appointment"}
              </Button>
            </Col>
          </Row>
        </div>
      }
      <br />
      {updatePatientInfoDialog && (
        <>
          <Modal
            size={"40%"}
            centered
            style={{ position: "fixed" }}
            opened={updatePatientInfoDialog}
            title={
              <div style={{ fontSize: "28px", fontWeight: "500" }}>
                Update missing profile details
              </div>
            }
            onClose={() => {
              !loadingProfileUpdate && closePatientInfoDialog();
              setSelectedFamilyMember(null);
            }}
          >
            <div>
              <br />
              {patientInfo && (
                <>
                  <Row>
                    <Col xs={12} sm={6} md={6} lg={6}>
                      <div className="navigo-module-create-service-field-container">
                        <div
                          className="navigo-module-label"
                          style={{ marginBottom: "4px" }}
                        >
                          Patient name
                        </div>
                        <div className="small-dropdown">
                          <TextInput
                            placeholder=""
                            value={`${patientInfo.firstName} ${patientInfo.lastName}`}
                            disabled
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <br />
                  {isDOBEmpty(patientInfo) && (
                    <>
                      <Row>
                        <Col xs={12} sm={6} md={6} lg={6}>
                          <div className="navigo-module-create-service-field-container">
                            <div
                              className="navigo-module-label"
                              style={{ marginBottom: "4px" }}
                            >
                              Date of birth
                              <label className="navigo-module-label-red">
                                *
                              </label>
                            </div>
                            <div className="small-dropdown">
                              <DatePicker
                                weekendDays={[]}
                                dropdownPosition="bottom-start"
                                placeholder="Choose a date"
                                clearable={false}
                                value={newDob}
                                onChange={(val) => {
                                  if (val) {
                                    const startOfDayUTC = dayjs(val).toDate();
                                    setNewDob(startOfDayUTC);
                                  }
                                }}
                                minDate={dayjs().subtract(100, "year").toDate()}
                                maxDate={dayjs().utc().startOf("day").toDate()}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <br />
                    </>
                  )}
                  {isEmailEmpty(patientInfo) && (
                    <>
                      <Row>
                        <Col xs={12} sm={6} md={6} lg={6}>
                          <div className="navigo-module-create-service-field-container">
                            <div
                              className="navigo-module-label"
                              style={{ marginBottom: "4px" }}
                            >
                              Email Id
                            </div>
                            <div className="small-dropdown">
                              <TextInput
                                placeholder=""
                                value={newEmail}
                                onChange={(e) => {
                                  const input = e.currentTarget.value;
                                  setNewEmail(input.trim());
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <br />
                    </>
                  )}
                </>
              )}

              <div>
                <Button
                  disabled={loading}
                  style={
                    loading
                      ? {
                          width: "100px",
                          height: "40px",

                          color: "#ffffff",
                          backgroundColor: "#c2c2c2",
                        }
                      : {
                          width: "100px",
                          height: "40px",

                          color: "#ffffff",
                          backgroundColor: "#ef7c01",
                        }
                  }
                  onClick={() => {
                    updatePatientInfo(patientInfo!);
                  }}
                >
                  Save
                </Button>
              </div>
            </div>
          </Modal>
        </>
      )}
      {isOpenAddAddress && (
        <Dialog open={isOpenAddAddress}>
          <div className="profile-address-top-heading">
            <h3>Address</h3>
            <Button
              className="profile-address-top-heading-back-button"
              style={{
                color: "#ffffff",
                backgroundColor: "#c2c2c2",
              }}
              onClick={() => {
                setIsOpenAddAddress(false);
              }}
            >
              BACK
            </Button>
          </div>
          <Row className="row-address-diag">
            <Col>
              <Row>
                <Col xs={12} sm={12} md={3} lg={4}>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    value={type}
                    options={addressTypes}
                    onChange={(e: any, v: any) => {
                      if (v) {
                        changeFields(v, "type");
                      }
                    }}
                    getOptionLabel={(option) => {
                      return option;
                    }}
                    renderInput={(params: any) => (
                      <TextField {...params} label="Address type" />
                    )}
                  />
                </Col>

                <Col xs={12} sm={12} md={3} lg={4}>
                  <TextField
                    style={{ width: "100%" }}
                    label="Full Name"
                    name="Full Name"
                    type="text"
                    // error={errorPinCode}
                    value={name || ""}
                    onChange={(value: any) => {
                      changeFields(value.target.value, "name");
                    }}
                    helperText={"Enter fullname"}
                  />
                </Col>
                <Col xs={12} sm={12} md={3} lg={4}>
                  <TextField
                    style={{ width: "100%" }}
                    label="Contact Number"
                    name="Contact Number"
                    type="text"
                    // error={errorPinCode}
                    value={phoneNo || ""}
                    inputProps={{ maxLength: 10 }}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      if (/^\d{0,10}$/.test(newValue)) {
                        changeFields(newValue, "phone");
                      }
                    }}
                    helperText={"Enter a valid number"}
                  />
                </Col>
              </Row>

              <Row style={{}}>
                <Col xs={12} sm={12} md={3} lg={3}>
                  <TextField
                    style={{ width: "100%" }}
                    label="Pincode"
                    name="pincode"
                    type="text"
                    // error={errorPinCode}
                    value={pincode || ""}
                    inputProps={{ maxLength: 6 }}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      if (/^\d{0,6}$/.test(newValue)) {
                        changeFields(newValue, e.target.name);
                      }
                    }}
                    helperText={"Fill Pincode"}
                  />
                </Col>{" "}
                <Col xs={12} sm={12} md={3} lg={3}>
                  <TextField
                    style={{ width: "100%" }}
                    label="District"
                    name="district"
                    type="text"
                    value={district}
                    onChange={(value: any) => {
                      // console.log("valuess", value.target.value)
                      changeFields(value.target.value, value.target.name);
                    }}
                    // lineDirection="center"
                  />
                </Col>{" "}
                <Col xs={12} sm={12} md={3} lg={3}>
                  <TextField
                    style={{ width: "100%" }}
                    label="State"
                    name="state"
                    type="text"
                    value={state || ""}
                    onChange={(value: any) => {
                      changeFields(value.target.value, value.target.name);
                    }}
                    // lineDirection="center"
                  />
                </Col>{" "}
                <Col xs={12} sm={12} md={3} lg={3}>
                  <TextField
                    style={{ width: "100%" }}
                    label="City"
                    name="city"
                    type="text"
                    value={city || ""}
                    onChange={(value: any) => {
                      changeFields(value.target.value, value.target.name);
                    }}
                    // lineDirection="center"
                  />
                </Col>{" "}
                <Col xs={12} sm={12} md={12} lg={12}>
                  <TextField
                    style={{ width: "100%", marginTop: "9px" }}
                    label="House No/Floor/Building "
                    name="line1"
                    type="text"
                    value={line1 || ""}
                    onChange={(value: any) => {
                      if (value.target.value.length > 60) {
                        value.target.value = value.target.value.slice(0, 60);
                      }
                      if (value.target.value.length < 61)
                        changeFields(value.target.value, value.target.name);
                    }}
                    // lineDirection="center"
                  />
                </Col>
                <Col xs={12} sm={6} md={8} lg={8}>
                  <TextField
                    style={{ width: "100%", marginTop: "9px" }}
                    label="Street/Area"
                    name="line2"
                    type="text"
                    value={line2 || ""}
                    onChange={(value: any) => {
                      if (value.target.value.length > 60) {
                        value.target.value = value.target.value.slice(0, 60);
                      }
                      if (value.target.value.length < 61)
                        changeFields(value.target.value, value.target.name);
                    }}

                    // lineDirection="center"
                  />
                </Col>
                <Col xs={12} sm={6} md={4} lg={4}>
                  <TextField
                    style={{ width: "100%", marginTop: "9px" }}
                    label="Landmark"
                    name="landmark"
                    type="text"
                    value={landmark || ""}
                    onChange={(value: any) => {
                      if (value.target.value.length > 30) {
                        value.target.value = value.target.value.slice(0, 30);
                      }
                      if (value.target.value.length < 31)
                        changeFields(value.target.value, value.target.name);
                    }}
                    // lineDirection="center"
                  />
                </Col>
              </Row>
              {errorFlag && (
                <Row>
                  <label style={{ color: "red" }}>Error in saving </label>
                </Row>
              )}
              <Row className="btn-dialog-address">
                <Button
                  className="btn-dialog-address-button"
                  style={{ color: "#ffffff", backgroundColor: "#ef7c01" }}
                  onClick={() => {
                    if (isAddressDataValid()) {
                      submit();
                    }
                  }}
                >
                  SAVE
                </Button>
              </Row>
            </Col>
          </Row>
        </Dialog>
      )}
      {openAssignPlanDialog && (
        <>
          <Modal
            size={"90%"}
            centered
            style={{ position: "fixed" }}
            opened={openAssignPlanDialog}
            withCloseButton={false}
            onClose={() => {
              !loadingAssignPlan && closeAssignPlanDialog();
            }}
          >
            <div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ fontWeight: "600", fontSize: "24px" }}>
                  Assign plan
                </div>
                <div style={{ display: "flex" }}>
                  <div>
                    <Button
                      disabled={loadingAssignPlan}
                      style={
                        loadingAssignPlan
                          ? {
                              textTransform: "none",
                              width: "100px",
                              height: "34px",
                              fontSize: "15px",
                              color: "#ffffff",
                              backgroundColor: "#c2c2c2",
                            }
                          : {
                              textTransform: "none",
                              width: "100px",
                              height: "34px",
                              fontSize: "15px",
                              color: "#ffffff",
                              backgroundColor: "#ef7c01",
                            }
                      }
                      onClick={() => {
                        isPlanAssignmentValid();
                      }}
                    >
                      Assign plan
                    </Button>
                  </div>
                  <div>
                    <Button
                      disabled={loadingAssignPlan}
                      style={{
                        textTransform: "none",
                        marginLeft: "24px",
                        width: "100px",
                        height: "34px",
                        fontSize: "15px",
                        color: "#ffffff",
                        backgroundColor: "#c2c2c2",
                      }}
                      onClick={() => {
                        !loadingAssignPlan && closeAssignPlanDialog();
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div className="table-content-height">
              <div
                style={{
                  fontWeight: "600",
                  fontSize: "20px",

                  marginBottom: "6px",
                }}
              >
                Select account
              </div>

              <div className="account-module-table-container">
                <div className="table">
                  <div className="table-header2">User's active accounts</div>
                  <div className="table-row1 table-header3">
                    <div className="table-cell" style={{ width: "5%" }}></div>
                    <div className="table-cell" style={{ width: "15%" }}>
                      Account ID
                    </div>
                    <div className="table-cell" style={{ width: "25%" }}>
                      Account name
                    </div>
                    <div className="table-cell" style={{ width: "15%" }}>
                      Account type
                    </div>
                    <div className="table-cell" style={{ width: "20%" }}>
                      KAM
                    </div>
                    <div className="table-cell" style={{ width: "20%" }}>
                      Plan status
                    </div>
                  </div>
                  {loadingTable ? (
                    <div
                      style={{
                        display: "flex",
                        height: "100px",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Loader color="orange" />
                    </div>
                  ) : accountsOnPid.length === 0 ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "20px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ marginBottom: "20px" }}>
                          No records to show
                        </div>
                        <img src={NoRecordsIcon} width={50} height={62} />
                      </div>
                    </div>
                  ) : (
                    accountsOnPid.map((acc) => {
                      return (
                        <div className="table-row1">
                          <div className="table-cell" style={{ width: "5%" }}>
                            {
                              <Radio
                                checked={
                                  accountRadioSelected === acc.accountCode
                                }
                                value={accountRadioSelected}
                                onChange={(event) =>
                                  setAccountRadioSelected(acc.accountCode)
                                }
                              />
                            }
                          </div>
                          <div className="table-cell" style={{ width: "15%" }}>
                            {acc.accountCode}
                          </div>
                          <div className="table-cell" style={{ width: "25%" }}>
                            {acc.accountName}
                          </div>
                          <div className="table-cell" style={{ width: "15%" }}>
                            {acc.mode}
                          </div>
                          <div className="table-cell" style={{ width: "20%" }}>
                            {acc.managerName}
                          </div>
                          <div className="table-cell" style={{ width: "20%" }}>
                            <div
                              className="status-select-active"
                              style={{
                                height: "25px",
                                width: "fit-content",
                                fontWeight: "bold",
                                fontSize: "12px",
                                cursor: "default",
                              }}
                            >
                              {acc.patientStatus === true ? "Active" : "-"}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
              {accountRadioSelected != "" && loadingTable2 === false && (
                <>
                  <br />
                  <div
                    style={{
                      fontWeight: "600",
                      fontSize: "20px",
                      marginBottom: "6px",
                    }}
                  >
                    Active plans on selected accounts
                  </div>

                  <div className="account-module-table-container">
                    <div className="table">
                      <div className="table-row1 table-header3">
                        <div
                          className="table-cell"
                          style={{ width: "5%" }}
                        ></div>
                        <div className="table-cell" style={{ width: "13%" }}>
                          Plan ID
                        </div>
                        <div className="table-cell" style={{ width: "20%" }}>
                          Plan name
                        </div>
                        <div className="table-cell" style={{ width: "13%" }}>
                          Created date
                        </div>
                        <div
                          className="table-cell-right"
                          style={{ width: "10%" }}
                        >
                          Plan price
                        </div>
                        <div className="table-cell" style={{ width: "13%" }}>
                          Plan duration
                        </div>
                        <div className="table-cell" style={{ width: "13%" }}>
                          Plan start date
                        </div>
                        <div className="table-cell" style={{ width: "13%" }}>
                          Plan end date
                        </div>
                      </div>
                      {loadingTable2 ? (
                        <div
                          style={{
                            display: "flex",
                            height: "100px",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Loader color="orange" />
                        </div>
                      ) : plansOnAccount.length === 0 ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "20px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ marginBottom: "20px" }}>
                              No records to show
                            </div>
                            <img src={NoRecordsIcon} width={50} height={62} />
                          </div>
                        </div>
                      ) : (
                        plansOnAccount.map((plan: any) => {
                          return (
                            <div className="table-row1">
                              <div
                                className="table-cell"
                                style={{ width: "5%" }}
                              >
                                {
                                  <Checkbox
                                    size="sm"
                                    color={
                                      isPlanAlreadyAssigned(plan.id)
                                        ? "gray"
                                        : "green"
                                    }
                                    disabled={isPlanAlreadyAssigned(plan.id)}
                                    checked={
                                      isPlanAlreadyAssigned(plan.id)
                                        ? true
                                        : isPlanSelected(plan.id)
                                    }
                                    onChange={(event) => {
                                      handlePlanSelection(plan.id);
                                    }}
                                  />
                                }
                              </div>
                              <div
                                className="table-cell"
                                style={{ width: "13%" }}
                              >
                                {plan.id}
                              </div>
                              <div
                                className="table-cell"
                                style={{ width: "20%" }}
                              >
                                {plan.basicDetails.name}
                              </div>
                              <div
                                className="table-cell"
                                style={{ width: "13%" }}
                              >
                                {dayjs(plan.createdAt)
                                  .utc()
                                  .format("DD MMM YYYY")}
                              </div>
                              <div
                                className="table-cell-right"
                                style={{ width: "10%" }}
                              >
                                {plan.basicDetails.price}
                              </div>
                              <div
                                className="table-cell"
                                style={{ width: "13%" }}
                              >
                                {`${plan.basicDetails.duration} days`}
                              </div>

                              <div
                                className="table-cell"
                                style={{ width: "13%" }}
                              >
                                {dayjs
                                  .utc(plan.basicDetails.startDate)
                                  .isSame(dayjs.utc("0001-01-01T00:00:00Z"))
                                  ? "NA"
                                  : dayjs
                                      .utc(plan.basicDetails.startDate)
                                      .format("DD MMM YYYY")}
                              </div>

                              <div
                                className="table-cell"
                                style={{ width: "13%" }}
                              >
                                {dayjs
                                  .utc(plan.basicDetails.endDate)
                                  .isSame(dayjs.utc("0001-01-01T00:00:00Z"))
                                  ? "NA"
                                  : dayjs
                                      .utc(plan.basicDetails.endDate)
                                      .format("DD MMM YYYY")}
                              </div>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </Modal>
        </>
      )}
      {openPlansAssignedDialog && (
        <>
          <Modal
            size={"60%"}
            centered
            style={{ position: "fixed" }}
            opened={openPlansAssignedDialog}
            withCloseButton={false}
            onClose={() => {
              closeAssignPlanResponseDialog();
            }}
          >
            <div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ fontWeight: "600", fontSize: "24px" }}>
                  Assigned plan result
                </div>
                <div>
                  <Button
                    style={{
                      textTransform: "none",
                      width: "100px",
                      height: "34px",
                      fontSize: "15px",
                      color: "#ffffff",
                      backgroundColor: "#ef7c01",
                    }}
                    onClick={() => {
                      closeAssignPlanResponseDialog();
                    }}
                  >
                    Ok
                  </Button>
                </div>
              </div>
            </div>
            <br />
            <div className="table-content-height-2">
              <Row>
                <Col xs={2} sm={2} md={2} lg={2}>
                  <div style={{ fontWeight: "bold" }}> {"Plan ID"}</div>
                </Col>
                <Col xs={2} sm={2} md={2} lg={2}>
                  <div style={{ fontWeight: "bold" }}> {"Result"}</div>
                </Col>
                <Col xs={8} sm={8} md={8} lg={8}>
                  <div style={{ fontWeight: "bold" }}> {"Message"}</div>
                </Col>
              </Row>
              <br />
              {plansSelected2.map((e: any, index: number) => {
                return (
                  <>
                    <Row>
                      <Col xs={2} sm={2} md={2} lg={2}>
                        {e}
                      </Col>
                      <Col xs={2} sm={2} md={2} lg={2}>
                        <div
                          style={
                            plansAssignmentResponse[index].error == ""
                              ? {
                                  fontWeight: "bold",
                                  backgroundColor: "#caecde",
                                  color: "#0b5033",
                                  padding: "3px",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                }
                              : {
                                  fontWeight: "bold",
                                  backgroundColor: "#fbdfd9",
                                  color: "#e44437",
                                  padding: "3px",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                }
                          }
                        >
                          {plansAssignmentResponse[index].error == ""
                            ? "Assigned"
                            : "Error"}
                        </div>
                      </Col>
                      <Col xs={8} sm={8} md={8} lg={8}>
                        {plansAssignmentResponse[index].error == ""
                          ? "Success"
                          : plansAssignmentResponse[index].error}
                      </Col>
                    </Row>
                    <br />
                  </>
                );
              })}
            </div>
          </Modal>
        </>
      )}
      <LocationSearchDialog
        dialogState={dialogState}
        setDialogState={setDialogState}
        closeDialog={closeDialog}
      />
      {/* Address flow: map dialog */}
      <LocationSearchDialog
        dialogState={addrEditDialogState}
        setDialogState={addrEditSetDialogState}
        closeDialog={addrEditCloseDialog}
      />
      {/* Address flow: form dialog */}
      <AddressFlowDialog
        flowState={addrFlowState}
        setFlowState={setAddrFlowState}
        closeFlow={closeAddrFlow}
        openLocationDialog={addrEditOpenLocationDialog}
        patientId={parseInt(patientIdTyped) || 0}
      />
      {showPaymentLinkDialog && aptPrice !== null && (
        <PaymentLinkDialog
          visible={showPaymentLinkDialog}
          onClose={() => {
            setShowPaymentLinkDialog(false);
            setLoading(false);
          }}
          withCreateAppointment={true}
          payloadForCreateAppointment={payloadForCreateAppointment}
          aptPrice={aptPrice}
          appointment={null}
          props={{
            setView: (_view: number, _data: any) => {
              exitPage();
            },
          }}
          profileDetails={patientDetails}
        />
      )}
    </div>
  );
}

export default CreateAppointment;
